<template src= "./detail.html"></template>

<script>
import Vue from 'vue'
import isEmpty from 'lodash/isEmpty'
import optionData from '@/optionData/data'
import _ from 'lodash'
import flatten from 'flat'
import {ko} from 'vuejs-datepicker/dist/locale'
import moment from 'moment'
import { format, isThisISOWeek } from 'date-fns'
import $api from '@/plugins/axiosInstance.js'
import $api2 from '@/plugins/axiosInstance2.js'
import swal from 'sweetalert2'
import { BtnDelete } from '../member/detail.vue'
import YtCidSearchLink from '../youtubeCid/components/YtCidSearchLink.vue'
import agTableComp from '@/optionData/agTableComp'
import axios from 'axios'
import { getMetadata, getThumbnails } from 'video-metadata-thumbnails';
import * as mmb from 'music-metadata-browser';
const CancelToken = axios.CancelToken;
export const BtnSelect = Vue.extend({
  name : 'btnSelect',
  template: `
      <vs-button class="btnSmall" @click="btnClickedHandler()" color="success" type="filled">{{title}}</vs-button>
    `,
  data(){
    return{
      title : ''
    }
  },
  created(){
    this.title = this.params.title ? this.params.title : '선택'
    
  },
  methods: {
    btnClickedHandler() {
      this.params.clicked(this.params.data);
    }
  },
});
export default {
  name: 'albumDetail',
  components: { YtCidSearchLink },
  data() {
    return {
      fileUrl: `${process.env.VUE_APP_API_URL}/file`,
      headers: {
        Authorization: `Bearer ${localStorage.getItem('srAccessToken')}`,
        'Access-Control-Allow-Origin': '*',
      },
      ko : ko,
      selectLicensor : [],
      optionData : optionData,
      memberOption : optionData.memberKeyword,
      page: {
        pageSize : 10,
        currentPage: 1,                       // 현재 페이지
        totalPage: 0,                         // 총 페이지수cline_text : this.cline_text
      },
      selectGenre : [],
      genreOption : [],

      albumGenre:[] ,
      albumStatusOption : optionData.albumStatus,
      albumStatus : null,

      sourceOption : optionData.albumSource,
      source : 'direct',
      releaseOption: optionData.releaseType,
      release_type : null,
      youtubeCIDOption:optionData.youtubeCID,
      youtube_cid : 'none' ,
      copyrightOption : optionData.copyrightType,
      youtube_sr : true,
      youtube_at : true,
      copyright : 'new',
      transfer_date : null,
      transfer_name : null,

      tractOption : optionData.trackType,
      trackTypeInput : null ,
      tractType :  null ,

      videoCount : 0,
      country : null ,
      original_release_date : null,
      release_date : null,
      release_time : '12:00:00',
      desired_release_date : null,
      tags : [[]],
      tags_v2 : [],

      contractDuration : null,
      contract : {
        service_fee_other :15,
        service_fee_kr :15,
        territory : null,
        territory_exception : null,
        territory_exception_v2 : [],
        start_date : null,
        end_date : null,
      },
      feeEditMode : false,
      //앨범 명
      name : null ,
      name_language : 'ko',
      name_english: null,
      coverimage: null,
      coverimage_id: null,
      //앨범 버전  
      release_version : null ,
      //기획사명
      label: null,
      label_english: null,
      label_language: 'ko',
      labelimage: null,
      labelimage_id: null,
      
      motionart11: null,
      motionart11_id : null,
      motionart34 : null,
      motionart34_id : null,
       
      motionartData : {
        motionart11: null,
        motionart11_id : null,
        motionart34 : null,
        motionart34_id : null,
  
      },

      playerOptions : {
        muted: true,
        language: 'en',
        playbackRates: [0.7, 1.0, 1.5, 2.0],
        sources: [{
          type: "video/quicktime",
          src: null
        }],
        poster: "/static/images/author.jpg",
      }, 
      credit :null,
      nationality : null,
      countryOption : optionData.country,
      languageOption : optionData.language,

      audioLanguageOption : [
        {"code":"zxx","name":"언어없음-ZXX","en_name":"No language-ZXX","original":"한국어"},
        ...optionData.language
      ],
      
      explicit : false,
      
      description_language: 'ko',
      description : null ,
      description_english : null,
      //유통사
      distributor : 'Sound Republica, Inc.',
      cline_text: null,
      cline_year: null,
      pline_text: "Sound Republica, Inc.",
      pline_year: null,
      album_ref :null,
      barcode:null,
      licensor_message : null,

      export_contract_preset_id: null,
      export_contract_preset_code: null,
      export_contract_preset_name: null,
      presetOptions: [],
      selectedPreset: null,
      presetDetailExpanded: false,
      presetSelecting: false,
      generateForm: {
        action: null,
        autostart: true,
      },
      generateActionOptions: [
        { value: 'insert', label: 'Insert' },
        { value: 'update', label: 'Update' },
        { value: 'takedown', label: 'Takedown' },
        { value: 'update_xml', label: 'Update XML' },
      ],
      generateResult: null,

      smartlink_url : null,
      smartlink_id : null,
      smartlink_ref : null,
      smartlink_type: null,
      smartlink_video_main_url: null,
      smartlink_video_sub_url: null,
      smartlink_color_box: null,
      smartlink_color_text: null,
      smartlink_description: null,
      linkAddress : null, // 링크 주소 변경



      has_mv : false,
      name_multilang : {
        ko : 'asdfasdf'
      },
      name_export : {

      },
      smartlinkEditValue : null,
      //
      gridOptions :{ // 테이블 옵션
          onRowClicked: (event)=>{
              
          },
      },
      defaultColDef: {
          sortable: false,
          editable: false,
          resizable: true,
          
          suppressMenu: false,
          rowSelection:'single'
      },
      columnDefs: [
        {headerName: 'E-mail ID', field: 'email', filter: false,width: 220,},
        {headerName: '권리자명 (성 이름)', field: 'licensor.family_name', filter: false,width: 150,
          cellRenderer: (data) => {
            let fm = data.data.licensor.family_name ? data.data.licensor.family_name : '';
            let gm = data.data.licensor.given_name ? data.data.licensor.given_name : '' ;
            return fm +' '+ gm
        }},
        {headerName: '회사명', field: 'licensor.company', filter: false,width: 150,},
        
        {headerName: '정산화폐', field: 'licensor.currency', filter: false,width: 150,
          cellRenderer: (data) => {
            const type = {
                'krw' : 'KRW',
                'usd' : 'USD',
                'eur' : 'EUR',
            }
            return type[data.value]
        }},
        {headerName: '사업자여부', field: 'licensor.entity', filter: false,width: 150, cellRenderer: (data) => {
            const type = {
                'individual' : '개인',
                'corporation' : '사업자',
            }
            return type[data.value]
        }},
        {headerName: '거주국가',  field: 'licensor.entity_address.country',  filter: false,width: 155,},
        {headerName: 'MIMS',  field: 'licensor.mims_account',  filter: false,width: 155,},
        {headerName: '정산요율', field: 'licensor.default_service_fee_kr', filter: false,width: 200, cellRenderer: (data) => {
            let text = ""
            text += "국내 : " + data.value + '%   '
            text += "해외 : " + data.data.licensor.default_service_fee_other + '%'
            return text
        }},
        {headerName: '상세보기', field: 'id', filter: false,width: 120,cellRenderer: (data) => {
          return `<a class="vs-component vs-button mr-3 vs-button-primary vs-button-gradient" href='/member/detail/${data.value}' target="_blank">
          
          <span class="vs-button-text vs-button--text">상세보기</span>
          </a>`
        }},
      ],

      // 라이센서 추가
      gridOptions5 :{ // 테이블 옵션 (같은 페이지에 있을때 공유해서 쓰면 에러)
        context: {
            componentParent: this
        },
        onGridReady: function (event) {
        },
        frameworkComponents : {
          btnSelect : BtnSelect
        }
      },
      columnDefsUser : [
        {headerName: '선택', field: 'id', filter: false,width: 100,
          cellRendererParams: {
            clicked: function(data) {
              this.context.componentParent.selectLicensorData(data)
              //this.context.componentParent.closeModal('licensor')
            }
          },
          cellRenderer: 'btnSelect'
        },
        {headerName: 'E-mail ID', field: 'email', filter: false,width: 220,},
        {headerName: '권리자명 (성 이름)', field: 'licensor.family_name', filter: false,width: 150,
          cellRenderer: (data) => {
            let fm = data.data.licensor.family_name ? data.data.licensor.family_name : '';
            let gm = data.data.licensor.given_name ? data.data.licensor.given_name : '' ;
            return fm +' '+ gm
        }},
        {headerName: '회사명', field: 'licensor.company', filter: false,width: 150,},
        
        {headerName: '정산화폐', field: 'licensor.currency', filter: false,width: 150,
          cellRenderer: (data) => {
            const type = {
                'krw' : 'KRW',
                'usd' : 'USD',
                'eur' : 'EUR',
            }
            return type[data.value]
        }},
        {headerName: '사업자여부', field: 'licensor.entity', filter: false,width: 150, cellRenderer: (data) => {
            const type = {
                'individual' : '개인',
                'corporation' : '사업자',
            }
            return type[data.value]
        }},
        {headerName: '거주국가',  field: 'licensor.entity_address.country',  filter: false,width: 155,},
        {headerName: 'MIMS',  field: 'licensor.mims_account',  filter: false,width: 155,},
        {headerName: '정산요율', field: 'licensor.default_service_fee_kr', filter: false,width: 200, cellRenderer: (data) => {
            let text = ""
            text += "국내 : " + data.value + '%   '
            text += "해외 : " + data.data.licensor.default_service_fee_other + '%'
            return text
        }},
      ],
      keywordType : {label:'권리자명', value:'_name'},
      licensorKeyword : '',
      
      userList: {
        listData: [],                 
        pageSize: 10,                 
        currentPage: 1,
        totalPage: 0,                
      },


      artistData :{
        gridOptions:{ // 테이블 옵션 (같은 페이지에 있을때 공유해서 쓰면 에러)
          context: {
              componentParent: this
          },
          onGridReady: function (event) {
          },
          frameworkComponents : {
            btnSelect : BtnSelect
          }
        },
        columnDefs : [
          {headerName: '선택', field: 'id', filter: false,width: 100,
            cellRendererParams: {
              clicked: function(data) {
                let list = this.context.componentParent.selectArtist
                let various = this.context.componentParent.variousArtist
                let found = list.find(element => element.id == data.id);
                let foundVarious = list.find(element => element.id == various.id);
                
                if(foundVarious!= undefined){
                  this.context.componentParent.selectArtist= [data]
                  this.context.componentParent.variousArtistStatus = false
                }else{
                  if(found == undefined) {
                    this.context.componentParent.selectArtist.push(data)
                  }else{
                    this.context.componentParent.alert({msg: '이미 선택된 아티스트입니다.'})
                  }
                }
                
                
                //this.context.componentParent.closeModal('artist')
              }
            },
            cellRenderer: 'btnSelect'
          },
          {headerName: '아티스트명', field: 'display_name', filter: false,width: 250,
          cellRenderer: (data) => {
              if(data.data.profile['thumbnail']){
                  return `<img class="artistTableImg" src="${data.data.profile['thumbnail']['remote_path']}"/>` + data.value
              }else{
                  return `<img class="artistTableImg" src="${data.data.profile['remote_path']}"/>` + data.value
              }
          }},
          {headerName: '아티스트명(번역)',  field: 'display_name_english',  filter: false,width: 250},
          {headerName: '등록일',      field: 'created_at',     filter: false,width: 200,
          cellRenderer: (data) => {
            return this.fixDate(data.value, 'yyyy-MM-dd HH:mm:ss')
          }},
        ],
      },

      artistKeywordOption : [
        {value: 'display_name', label: '아티스트명'},
        {value: 'display_name_english', label: '아티스트명(번역)'}
      ],
      artistKeywordType : {value: 'display_name', label: '아티스트명'},
      artistKeyword : null,
      artistList: {
        listData: [],                 
        pageSize: 5,                 
        currentPage: 1,
        totalPage: 0,                
      },
      selectArtist : [],
      variousArtist : [],
      variousArtistStatus : false,
      // track
      trackData :{
        gridOptions:{ // 테이블 옵션 (같은 페이지에 있을때 공유해서 쓰면 에러)
          context: {
              componentParent: this
          },
          onGridReady: function (event) {
          },
          frameworkComponents : {
            btnSelect : BtnSelect
          }
        },
        columnDefs : [
          {headerName: '선택', field: 'id', filter: false,width: 100,
            cellRendererParams: {
              clicked: function(data) {
                let list = this.context.componentParent.selectTrackArtist
                let various = this.context.componentParent.variousArtist
                let found = list.find(element => element.id == data.id);
                let foundVarious = list.find(element => element.id == various.id);
                
                if(foundVarious!= undefined){
                  this.context.componentParent.selectTrackArtist= [data]
                  this.context.componentParent.variousTrackArtistStatus = false
                }else{
                  if(found == undefined) {
                    this.context.componentParent.selectTrackArtist.push(data)
                  }else{
                    this.context.componentParent.alert({msg: '이미 선택된 아티스트입니다.'})
                  }
                }
                
                
                //this.context.componentParent.closeModal('artist')
              }
            },
            cellRenderer: 'btnSelect'
          },
          {headerName: '아티스트명', field: 'display_name', filter: false,width: 250,
          cellRenderer: (data) => {
              if(data.data.profile['thumbnail']){
                  return `<img class="artistTableImg" src="${data.data.profile['thumbnail']['remote_path']}"/>` + data.value
              }else{
                  return `<img class="artistTableImg" src="${data.data.profile['remote_path']}"/>` + data.value
              }
          }},
          {headerName: '아티스트명(번역)',  field: 'display_name_english',  filter: false,width: 250},
          {headerName: '등록일',      field: 'created_at',     filter: false,width: 200,
          cellRenderer: (data) => {
            return this.fixDate(data.value, 'yyyy-MM-dd HH:mm:ss')
          }},
        ],
      },
      trackAll : [],
      trackList : [[]],
      trackWorkAssign: {},
      parentalOtion:[
        {label : 'explicit', value : "explicit"},
        {label : 'not_explicit', value : "not_explicit"},
        {label : 'explicit_content_edited', value : "explicit_content_edited"},
        {label : 'user_defined', value : "user_defined"},
        {label : 'no_advice_available', value : "no_advice_available"},
        {label : 'unknown', value : "unknown"},
      ],
      trackModalMode : null,
      trackTemplate :{
        name : '',
        name_language : 'ko',
        name_english : '',
        name_multilang : {},
        name_export : {},
        genre1_id :null,
        genre2_id : null,

        artists : [],
        files : [],
        contributors : [],
        featuring_artists:'',
        featuring_artists_english:'',
        featuring_artists_language:'ko',
        lyrics : '',
        lyrics_language :'ko' ,
        parental_warning : 'not_explicit', //'explicit', 'explicit_content_edited', 'not_explicit', 'unknown'
        titletrack : 0,
        explicit : false,
        tracknr: 1,
        //track_ref: '',
        type : 'original',// 트랙유형
        alt_type : null,
        uci : '',
        uci_generate :false,
        isrc : '',
        isrc_generate :false,
        is_takedown : false,
        volume : 1,
        iswc: '',
        track_preview: [],
      },
      
      trackDetail :{
        name : '',
        name_language : null,
        name_multilang : {},
        name_export : {},
        name_english : '',
        genre1_id :null,
        genre2_id : null,
        isrc : '',
        artists : [],
        files : [],
        featuring_artists:'',
        featuring_artists_english:'',
        featuring_artists_language:'',
        lyrics : '',
        lyrics_language :'ko' ,
        dolbyatmos_isrc : null,
        contributors : [],
        contributors_v2 : [],
        parental_warning : 'not_explicit', // not_explicit , explicit
        explicit : false,
        titletrack : 0,
        tracknr: 1,
        //track_ref: '',
        type : 'original',// 트랙유형
        alt_type : null,
        uci : null,
        iswc: '',
        volume : 1,
        is_takedown : false,
        album_work_id: null,
        movement_nr: null,
        track_preview: [],
      },
      
      contributorsRole :'composer',
      contributorsRoleOption : optionData.contributors,
      contributorsName : null,
      contributorsCompany : null,
      contributorsIpi : null,

      showPreviewPicker: false,
      previewPlayingId: null,
      previewPlatformOptions: [{ label: 'TikTok', value: 'tiktok' }],
      variousTrackArtistStatus : false,
      trackGenre : [],
      selectTrackArtist : [],
      trackTypeOption : optionData.trackType,
      trackTitleOption : [
        {label : '대표곡 NO',value :0},
        {label : 'Y1',value :1},
        {label : 'Y2',value :2},
        {label : 'Y3',value :3},
        {label : 'Y4',value :4},
      ],

      files1 : [], // 앨범
      files2 : [], // 앨범
      files3 : [], // 앨범
      files4 : [], // monitoring
      files5 : [], // dolby
      files6 : [], // appledigitalmaster

      file1: {
        id :null,
        preview : ''
      },// profile
      file2: {
        id :null,
        preview : ''
      },
      file3: {
        id :null,
        preview : ''
      },
      file4: {
        id :null,
        preview : ''
      },
      file5: {
        id :null,
        preview : ''
      },
      file6: {
        id :null,
        preview : ''
      },
      accept:"",
      extensions:'',
      multiple: false,
      directory: false,
      drop: true,
      dropDirectory: true,
      addIndex: false,
      thread: 3,
      
      uploadAuto: false,

      selectMemo : null    ,
      memo: {
        listData: [],                  // 메모 리스트데이터
        pageSize: 0,                 // 메모 리스트 총 페이징
        currentPage: 1,
        totalPage: 0,                // 메모 리스트 페이징
        memoText : '',
        limit_box: {
          limit_model: 10,
          limit: [ // 리스트 제한갯수
            {value: 10, label: "10"},
            {value: 20, label: "20"},
            {value: 30, label: "30"},
            {value: 50, label: "50"},
          ],
        },
        defaultColDef: {
          sortable: false,
          editable: false,
          resizable: true,
          suppressMenu: false,
          rowSelection:'single'
        },
        columnDefs: [
          {headerName: '등록일', field: 'created_at', filter: false,resizable:true, minWidth: 175,
            cellRenderer: (data) => {
            return this.fixDate(data.value, 'yyyy-MM-dd HH:mm:ss')
          }},
          {headerName: '내용',  field: 'text',  resizable:true, filter: false, minWidth: 450,cellRenderer: (data) => {
            return `<div>${data.value}</div>`
          }},
          {headerName: '관리자', field: 'user.admin_nickname', filter: false,minWidth: 200,},
          {headerName: '상세보기', field: 'text', filter: false,minWidth: 140,
            cellRendererParams: {
              clicked: function(data) {
                let text = data.text
                this.context.componentParent.confirm({
                  title : '메모 상세보기',
                  msg : `
                    <div class="vx-card" style="padding:5px;">
                      <textarea style=" color:inherit; height:auto; min-height:200px;" class="vs-textarea" readonly>${text}</textarea>
                    <div>
                  `,
                  action :()=>{}
                })
                
                
              }
            },
            cellRendererSelector: (data) => {
                  let dd={
                    component: 'btnSelect',
                    params: {
                        ...data.data,
                        title: '상세보기'
                    }
                } ;
                // if(this.selectTrack.track_id ==  data.data.track_id ){
                //     dd.params['disabled'] = true
                //     dd.params['title'] = '선택완료'
                // }
                
                return dd
            }
          },
          {headerName: '메모삭제', field: 'id', filter: false,minWidth: 140,
            cellRendererParams: {
              clicked: function(data) {
                this.context.componentParent.openModal('removeMemo');
                this.context.componentParent.selectMemo = data.id
                
              }
            },
            cellRenderer: 'btnDelete'
          },
        ],

        
        gridOptions :{ // 테이블 옵션 (같은 페이지에 있을때 공유해서 쓰면 에러)
          context: {
              componentParent: this
          },
          onGridReady: function (event) {
              event.api.sizeColumnsToFit();
          },
          frameworkComponents : {
            btnSelect : agTableComp.btnSelect,
            btnDelete : BtnDelete
          }
        },
      },
      selectData : {},

      audioList : [],
      audioiSrc : null,

      uciResult : {
        listData: [],                  // 메모 리스트데이터
        pageSize: 0,                 // 메모 리스트 총 페이징
        currentPage: 1,
        totalPage: 0,                // 메모 리스트 페이징
        memoText : '',
        limit_box: {
          limit_model: 10,
          limit: [ // 리스트 제한갯수
            {value: 10, label: "10"},
            {value: 20, label: "20"},
            {value: 30, label: "30"},
            {value: 50, label: "50"},
          ],
        },
        defaultColDef: {
          sortable: false,
          editable: false,
          resizable: true,
          suppressMenu: false,
          rowSelection:'single'
        },

        columnDefs: [
          {headerName: 'Volume', field: 'volume', filter: false,width: 100,},
          {headerName: 'Track#', field: 'tracknr', filter: false,width: 100,},
          {headerName: '트랙명',  field: 'name',  filter: false,width: 150,},
          {headerName: '발급결과', field: 'result', filter: false,width: 250,cellRenderer: (data) => {
            let text = ''
            if(!data.data.success){
              text = `<span style="color:#ce5a5a"> ${data.value} </span>`
            }else{
              text = `<span> ${data.value} </span>`
            }
            return text
          }},
          
        ],
        gridOptions :{ // 테이블 옵션 (같은 페이지에 있을때 공유해서 쓰면 에러)
          context: {
              componentParent: this
          },
          onGridReady: function (event) {
          },
          frameworkComponents : {
            btnSelect : BtnSelect,
            btnDelete : BtnDelete
          }
        },
      },

      
      rejectList : {
        listData: [],                  // 메모 리스트데이터
        
        // created_at: "2021-01-14T08:53:42.572Z"
        // id: 7
        // message: "ddd"
        // updated_at: "2021-01-14T08:53:42.572Z"
        columnDefs: [
          {headerName: '반려일시', field: 'created_at', filter: false,width: 200,cellRenderer: (data) => {
            return this.fixDate(data.value, 'yyyy-MM-dd HH:mm:ss')
          }},
          {headerName: '반려사유',cellClass: "cell-wrap-text", wrapText: true, field: 'message', filter: false,width: 350,cellRenderer: (data) => {
            return `${data.value}`
          }},
          
        ],
        defaultColDef: {
          sortable: false,
          editable: false,
          resizable: true,
          wrapText: true,
          autoHeight: true,
          suppressMenu: false,
          rowSelection:'single'
        },
        gridOptions :{ // 테이블 옵션 (같은 페이지에 있을때 공유해서 쓰면 에러)
          context: {
              componentParent: this
          },
          getRowHeight: function(params) {
              // assuming 50 characters per line, working how how many lines we need
              return 18 * (Math.floor(params.data.latinText.length / 45) + 1);
          },
          onGridReady: function (event) {
           
          },
          frameworkComponents : {
            btnSelect : BtnSelect,
            btnDelete : BtnDelete
          }
        },
      },
      rejectMemo : null,

      errorAlbumCode : {
        listData: [],                  // 메모 리스트데이터
        currentPage : 1,
        totalPage : 0,
        columnDefs: [
          {headerName: '자사앨범코드', field: 'album_ref', filter: false,width: 200,cellRenderer: (data) => {
            return data.value
          }},
          {headerName: '계약사', field: 'aggregator_name', filter: false,width: 200,cellRenderer: (data) => {
            return data.value
          }},
          {headerName: '대체코드 유형', field: 'type', filter: false,width: 200,cellRenderer: (data) => {
            return data.value
          }},
          {headerName: '대체코드', field: 'code', filter: false,width: 200,cellRenderer: (data) => {
            return data.value
          }},
          
          {headerName: '등록일시', field: 'created_at', filter: false,width: 200,cellRenderer: (data) => {
            return this.fixDate(data.value, 'yyyy-MM-dd HH:mm:ss')
          }},
        ],
        defaultColDef: {
          sortable: false,
          editable: false,
          resizable: true,
          wrapText: true,
          autoHeight: true,
          suppressMenu: false,
          rowSelection:'single'
        },
        gridOptions :{ // 테이블 옵션 (같은 페이지에 있을때 공유해서 쓰면 에러)
          context: {
              componentParent: this
          },
          
          onGridReady: function (event) {
            
          },
          frameworkComponents : {
            btnSelect : BtnSelect,
            btnDelete : BtnDelete
          }
        },
        
        
      },
      errorAlbumName : {
        listData: [],                  // 메모 리스트데이터
        currentPage : 1,
        totalPage : 0,
        columnDefs: [
          {headerName: '자사앨범코드', field: 'album_ref', filter: false,width: 200,cellRenderer: (data) => {
            return data.value
          }},
          {headerName: '계약사', field: 'aggregator_name', filter: false,width: 200,cellRenderer: (data) => {
            return data.value
          }},
          {headerName: '대체명', field: 'substitute_name', filter: false,width: 200,cellRenderer: (data) => {
            return data.value
          }},
          {headerName: '등록일시', field: 'created_at', filter: false,width: 200,cellRenderer: (data) => {
            return this.fixDate(data.value, 'yyyy-MM-dd HH:mm:ss')
          }},
        ],
        defaultColDef: {
          sortable: false,
          editable: false,
          resizable: true,
          wrapText: true,
          autoHeight: true,
          suppressMenu: false,
          rowSelection:'single'
        },
        gridOptions :{ // 테이블 옵션 (같은 페이지에 있을때 공유해서 쓰면 에러)
          context: {
              componentParent: this
          },
          
          onGridReady: function (event) {
            
          },
          frameworkComponents : {
            btnSelect : BtnSelect,
            btnDelete : BtnDelete
          }
        },
      },
      errorTrackCode : {
        listData: [],                  // 메모 리스트데이터
        currentPage : 1,
        totalPage : 0,
        // aggregator_name: null
        // code: "5060125260821_01_008"
        // created_at: "2021-05-31T03:33:05.257Z"
        // track_name: "Sneen Danser"
        // track_ref: "SRAB04907801008"
        // type: "proprietary"
        columnDefs: [
          {headerName: '자사트랙코드', field: 'track_ref', filter: false,width: 200,cellRenderer: (data) => {
            return data.value
          }},
          {headerName: '트랙명', field: 'track_name', filter: false,width: 200,cellRenderer: (data) => {
            return data.value
          }},
          {headerName: '계약사', field: 'aggregator_name', filter: false,width: 200,cellRenderer: (data) => {
            return data.value
          }},
          {headerName: '대체코드', field: 'code', filter: false,width: 200,cellRenderer: (data) => {
            return data.value
          }},
          {headerName: '대체코드유형', field: 'type', filter: false,width: 200,cellRenderer: (data) => {
            return data.value
          }},
          {headerName: '등록일시', field: 'created_at', filter: false,width: 200,cellRenderer: (data) => {
            return this.fixDate(data.value, 'yyyy-MM-dd HH:mm:ss')
          }},
        ],
        defaultColDef: {
          sortable: false,
          editable: false,
          resizable: true,
          wrapText: true,
          autoHeight: true,
          suppressMenu: false,
          rowSelection:'single'
        },
        gridOptions :{ // 테이블 옵션 (같은 페이지에 있을때 공유해서 쓰면 에러)
          context: {
              componentParent: this
          },
          
          onGridReady: function (event) {
            
          },
          frameworkComponents : {
            btnSelect : BtnSelect,
            btnDelete : BtnDelete
          }
        },
      },
      errorTrackName : {
        listData: [],                  // 메모 리스트데이터
        currentPage : 1,
        totalPage : 0,
        columnDefs: [
          {headerName: '자사트랙코드', field: 'track_ref', filter: false,width: 200,cellRenderer: (data) => {
            return data.value
          }},
          {headerName: '트랙명', field: 'track_name', filter: false,width: 200,cellRenderer: (data) => {
            return data.value
          }},
          {headerName: '계약사', field: 'aggregator_name', filter: false,width: 200,cellRenderer: (data) => {
            return data.value
          }},
          {headerName: '대체명', field: 'substitute_name', filter: false,width: 200,cellRenderer: (data) => {
            return data.value
          }},
          {headerName: '등록일시', field: 'created_at', filter: false,width: 200,cellRenderer: (data) => {
            return this.fixDate(data.value, 'yyyy-MM-dd HH:mm:ss')
          }},
        ],
        defaultColDef: {
          sortable: false,
          editable: false,
          resizable: true,
          wrapText: true,
          autoHeight: true,
          suppressMenu: false,
          rowSelection:'single'
        },
        gridOptions :{ // 테이블 옵션 (같은 페이지에 있을때 공유해서 쓰면 에러)
          context: {
              componentParent: this
          },
          
          onGridReady: function (event) {
            
          },
          frameworkComponents : {
            btnSelect : BtnSelect,
            btnDelete : BtnDelete
          }
        },
      },
      contractFile : null,
      //linkList : ['melon', 'genie', 'flo', 'bugs', 'vibe', 'spotify', 'applemusic', 'youtube', 'soribada',"ccmpia"]
      albumLinkList : [
        {name :'MELON', type : 'melon', link : null, edit : false},
        {name :'GENIE', type : 'genie', link : null, edit : false},
        {name :'FLO', type : 'flo', link : null, edit : false},
        {name :'BUGS', type : 'bugs', link : null, edit : false},
        {name :'VIBE', type : 'vibe', link : null, edit : false},
        {name :'SPOTIFY', type : 'spotify', link : null, edit : false},
        {name :'APPLEMUSIC', type : 'applemusic', link : null, edit : false},
        {name :'YOUTUBE', type : 'youtube', link : null, edit : false},
        {name :'DEEZER', type : 'deezer', link : null, edit : false},
        {name :'QQMUSIC', type : 'qqmusic', link : null, edit : false},
        {name :'AMAZON', type : 'amazon', link : null, edit : false},
        {name :'TIDAL', type : 'tidal', link : null, edit : false},
        {name :'PANDORA', type : 'pandora', link : null, edit : false},
        {name :'BeatPort', type : 'beatport', link : null, edit : false},
      ],
      albumLinkListCopy : [
        {name :'MELON', type : 'melon', link : null, edit : false},
        {name :'GENIE', type : 'genie', link : null, edit : false},
        {name :'FLO', type : 'flo', link : null, edit : false},
        {name :'BUGS', type : 'bugs', link : null, edit : false},
        {name :'VIBE', type : 'vibe', link : null, edit : false},
        {name :'SPOTIFY', type : 'spotify', link : null, edit : false},
        {name :'APPLEMUSIC', type : 'applemusic', link : null, edit : false},
        {name :'YOUTUBE', type : 'youtube', link : null, edit : false},
        {name :'DEEZER', type : 'deezer', link : null, edit : false},
        {name :'QQMUSIC', type : 'qqmusic', link : null, edit : false},
        {name :'AMAZON', type : 'amazon', link : null, edit : false},
        {name :'TIDAL', type : 'tidal', link : null, edit : false},
        {name :'PANDORA', type : 'pandora', link : null, edit : false},
        {name :'BeatPort', type : 'beatport', link : null, edit : false},
      ],
 
      
      
      
      video: {
        listData: [],                  // 메모 리스트데이터
        pageSize: 0,                 // 메모 리스트 총 페이징
        currentPage: 1,
        totalPage: 0,                // 메모 리스트 페이징
        memoText : '',
        limit_box: {
          limit_model: 10,
          limit: [ // 리스트 제한갯수
            {value: 10, label: "10"},
            {value: 20, label: "20"},
            {value: 30, label: "30"},
            {value: 50, label: "50"},
          ],
        },
        defaultColDef: {
          sortable: false,
          editable: false,
          resizable: true,
          suppressMenu: false,
          rowSelection:'single'
        },
        columnDefs: [
          
        ],
        gridOptions :{ // 테이블 옵션 (같은 페이지에 있을때 공유해서 쓰면 에러)
          context: {
              componentParent: this
          },
          onGridReady: function (event) {
              event.api.sizeColumnsToFit();
          },
          frameworkComponents : {
            btnSelect : agTableComp.btnSelect,
            btnDelete : BtnDelete
          }
        },
      },
      selectFile : null,        // 선택파일ID 삭제용
      file: {
        listData: [],                  // 메모 리스트데이터
        pageSize: 0,                 // 메모 리스트 총 페이징
        currentPage: 1,
        totalPage: 0,                // 메모 리스트 페이징
      },
      files: [],              // 파일 데이터
      accept:"",
      extensions:'',
      multiple: false,
      directory: false,
      drop: true,
      dropDirectory: true,
      addIndex: false,
      thread: 3,
      name: 'file',

      videoEditMode : false,
      videoFile : [],
      videoThumnailFile : [],
      videoReviewFile : [],
        
      trackOption : [],
      selectTrack  : null,
      videoData : {
        video_id : null,
        track_id :  null,
        type : 'mv', //  (mv, teaser, makingof, other)
        is_reviewed : false,
        review_office : null,
        review_date :null ,
        review_classification : null,
        thumbnail_id : null,
        language : null,
        title : null,
        description : null,
        file_id : null,
        barcode : null,
        isrc : null,
        start_date: null,
        start_time: null,
        start_timezone: null,
        end_date: null,
        end_time: null,
        end_timezone: null,
      },
      classificationOption : ['전체', '7세이상', '12세이상', '15세이상' ,'19세이상'],
      officeOption : ['영등위', 'SBS MTV', 'MBC MUSIC' ,'CMTV','심의제외'],
      officeOptionSelect : null,
      ingestionCount : 0,
      ingestionDate : null,
      ingestionData : {
        listData: [],                  // 메모 리스트데이터
        currentPage : 1,
        totalPage : 0,
        columnDefs: [
          //DATE , ACTION , SOURCE , FEED , BATCH ID , UPC/EAN , (XML) / (FILE) ,  STATUS , ERROR
          {headerName: '등록일시', field: 'created_at', filter: false,width: 200,cellRenderer: (data) => {
            return this.fixDate(data.value, 'yyyy-MM-dd HH:mm:ss')
          }},
          {headerName: 'Action', field: 'action', filter: false,width: 100,cellRenderer: (data) => {
            return data.value
          }},
          {headerName: 'Source', field: 'source', filter: false,width: 300,cellRenderer: (data) => {
            return data.value
          }},
          {headerName: 'FEED', field: 'feed', filter: false,width: 300,cellRenderer: (data) => {
            return data.value
          }},
          {headerName: 'BATCH ID', field: 'batch_id', filter: false,width: 200,cellRenderer: (data) => {
            return data.value
          }},
          {headerName: 'UPC/EAN', field: 'xml_content', filter: false,minWidth: 140,
            cellRendererParams: {
              clicked: function(data) {
                let text = data.xml_content
                this.context.componentParent.confirm({
                  title : 'xml_content 상세보기',
                  width:1000,
                  msg : `
                    <div class="vx-card" style="padding:5px; text-align:left; padding:10px;">
                      <textarea style="background:transparent; width:100%; height:400px; resize:none; color:inherit; word-wrap: break-word; white-space: pre-wrap;">${""+ String(text)} </textarea>
                    <div>
                  `,
                  action :()=>{}
                })
                
              }
            },
            cellRendererSelector: (data) => {
                  let dd={
                    component: 'btnSelect',
                    params: {
                        ...data.data,
                        title: data.data.icpn
                    }
                } ;
                // if(this.selectTrack.track_id ==  data.data.track_id ){
                //     dd.params['disabled'] = true
                //     dd.params['title'] = '선택완료'
                // }
                
                return dd
            }
          },
          {headerName: 'Resource', field: 'resources', filter: false,minWidth: 140,
            cellRendererParams: {
              clicked: function(data) {
                let text = data.resources
                this.context.componentParent.confirm({
                  title : 'resources 상세보기',
                  width:1000,
                  msg : `
                    <div class="vx-card" style="padding:5px; text-align:left; padding:10px;">
                      <textarea style="background:transparent; width:100%; height:400px; resize:none; color:inherit; word-wrap: break-word; white-space: pre-wrap;">${""+ String(text)} </textarea>
                    <div>
                  `,
                  action :()=>{}
                })
                
              }
            },
            cellRendererSelector: (data) => {
                  let dd={
                    component: 'btnSelect',
                    params: {
                        ...data.data,
                        title: 'resources'
                    }
                } ;
                // if(this.selectTrack.track_id ==  data.data.track_id ){
                //     dd.params['disabled'] = true
                //     dd.params['title'] = '선택완료'
                // }
                
                return dd
            }
          },
          {headerName: '상태', field: 'status', filter: false,width: 200,cellRenderer: (data) => {
            return data.value
          }},
          {headerName: '에러', field: 'error_type', filter: false,width: 200,cellRenderer: (data) => {
            return data.value
          }},
        ],
        defaultColDef: {
          sortable: false,
          editable: false,
          resizable: true,
          wrapText: true,
          autoHeight: true,
          suppressMenu: false,
          rowSelection:'single'
        },
        gridOptions :{ // 테이블 옵션 (같은 페이지에 있을때 공유해서 쓰면 에러)
          context: {
              componentParent: this
          },
          
          onGridReady: function (event) {
            
          },
          frameworkComponents : {
            btnSelect : BtnSelect,
            btnDelete : BtnDelete
          }
        },
        
        
      },
      

      djData :{
        totla : 0,
        listData: [],                  // 메모 리스트데이터
        currentPage : 1,
        totalPage : 0,
        columnDefs: [

          // album_count: 1
          // amount_remaining: 40072232.84693845
          // amount_total: 42906150
          // created_at: "2021-12-13T07:11:07.445Z"
          // end_date: null
          // id: 5
          // licensor_id: 1813
          // ref_code: "AP0005"
          // service_fee: 15
          // start_date: "2021-10-21"
          // updated_at: "2022-01-05T02:44:11.094Z"
          // user_company: "리플라이프로젝트"
          // licensor.currency: "krw"
          // user_email: "reflyproject@soundrepublica.com"
          // user_family_name: "노"
          // user_given_name: "건식"
          // user_name: "노 건식"

          {headerName: 'DJ 코드', field: 'export_job_ref_code', filter: false,width: 180,
              cellRendererParams: {
                  clicked: function(data) {
                      this.context.componentParent.djViewDetail(data.export_job_id);
                  },
              },
              cellRendererSelector: (data) => {
                  let dd={
                      component: 'textButton',
                      params: {
                          ...data.data,
                          text: data.value,
                          style: 'color: rgba(var(--vs-primary), 1); cursor : pointer'
                      }
                  } ;
                  // if(this.selectTrack.track_id ==  data.data.track_id ){
                  //     dd.params['disabled'] = true
                  //     dd.params['title'] = '선택완료'
                  // }
                  
                  return dd
              }
          },
          {headerName: 'DJ 계약사',  field: 'export_contract_name',  filter: false,width: 250,cellRenderer: (data) => {
              let t = data.value
              
              return `<div class="cellCenter"><span>${t}</span></div>`
          }},
          {headerName: 'Batch Action',  field: 'batch_action',  filter: false,width: 150,cellRenderer: (data) => {
         
              return data.value ? data.value.toUpperCase() : ''
          }},
          {headerName: 'Batch 상태',  field: 'batch_state',  filter: false,width: 180,
          
          cellRendererSelector: (data) => {
            let text ={
                'registered' : '등록',
                'await_packaging':'패키징 대기',
                'is_packaging' : '패키징',
                'packaging_failed' : '패키징실패',
                'is_delivering' : '전송',
                'await_delivery' : '전송대기',
                'delivery_success' : '전송완료',
                'delivery_failed' : '전송실패',
            }
            let color ={
                'delivery_success' : '#239351',
                'delivery_failed' : '#f9383f',
                'is_delivering' : '#a412b5',
                'await_delivery' : '#a457ad',
                'registered' : '#545353',
                'is_packaging' : '#3340ed',
                'await_packaging':'#529adb',
                'packaging_failed' : '#f9383f',
          }
            let t = data.value
              let dd={
                  component: 'tooltipCustom',
                  params: {
                      ...data.data,
                      text : data.data.ej_err_msg? data.data.ej_err_msg : '',
                      html: `<div class="cellCenter"><span class="textCenter" style=" min-width:80px; color:#fff; padding: 3px 8px; border-radius:8px; background : ${color[t]}">${text[t]}</span></div>`,
                  }
              } ;
              // if(this.selectTrack.track_id ==  data.data.track_id ){
              //     dd.params['disabled'] = true
              //     dd.params['title'] = '선택완료'
              // }
              
              return dd
      },
          },
        
          {headerName: '등록일시',      field: 'registration_date',     filter: false,width: 200, cellRenderer: (data) => {
                return `<div class="cellCenter"><span>${data.value ? this.fixDate(data.value , 'yyyy-MM-dd HH:mm') : ''}</span></div>`
          }},
          
          {headerName: '작업시작일시',      field: 'started_at',     filter: false,width: 200, cellRenderer: (data) => {
                return `<div class="cellCenter"><span>${data.value ? this.fixDate(data.value , 'yyyy-MM-dd HH:mm') : ''}</span></div>`
          }},
          {headerName: '작업종료일시',      field: 'finished_at',     filter: false,width: 200, cellRenderer: (data) => {
                return `<div class="cellCenter"><span>${data.value ? this.fixDate(data.value , 'yyyy-MM-dd HH:mm') : ''}</span></div>`
          }},
  
        ],
        defaultColDef: {
          sortable: false,
          editable: false,
          resizable: true,
          wrapText: true,
          autoHeight: true,
          suppressMenu: false,
          rowSelection:'single'
        },
        gridOptions :{ // 테이블 옵션 (같은 페이지에 있을때 공유해서 쓰면 에러)
          context: {
              componentParent: this
          },
          
          onGridReady: function (event) {
            
          },
          frameworkComponents : {
              ...agTableComp
          },
        },
      },

      contractLicensorList : [],
      is_even_distribution: false,


      service_fee_kr : 0,
      service_fee_other : 0,

      transcoding_in_progress : false,
      mp3File : true,
      wavFile : true,
      flacFile : true,
      monitoring:{
        totla : 0,
        listData: [],                  // 메모 리스트데이터
        currentPage : 1,
        totalPage : 0,
      },
      monitoringData : {
        store : null,
        page_type : null,
        page: null,
        url  : null,
      },
      gsurl :'https://lookerstudio.google.com/embed/reporting/7631eee1-dbf7-4e24-9a04-83207cb4ee49/page/p_8dfhf5rq7c?params={"salesline_album_id":'+ this.$route.params.id+'}',

      sr_representative : null,
      managerList : [],

      artistText : null,


      textColor : '#4b4b4b',
      boxColor : '#ffffff',
      linkType: 'image' ,// image , video, imageVideo
      linkText : '',
      mainVideo: 'https://www.youtube.com/embed/5upURU12pGw?autoplay=1&mute=1&showinfo=0&controls=0&loop=1" frameborder="0',
      subVideo : 'https://www.youtube.com/embed/5upURU12pGw?autoplay=1&mute=1&showinfo=0&controls=0&loop=1" frameborder="0',
      releaseType : 'release',
      dspList: ['melon', 'genie','bugs','vibe','flo','spotify','deezer','youtube','tidal','apple','amazone','qq'],
      
      
      
      
      barcodeGenerate: true,
      isrcGenerate: true,
      uciGenerate: true,
      code_generation_in_progress : false,



      editType : 'new', // new, modify
      generate_new_barcode : null,
      existing_barcode :null,
      generate_new_isrc : null,
      existing_isrc: null,
      codeReason : null,

      lyrics_language_all : null,

      exceptionCountry : null,


      selectFeaturingArtist : [],
      featuringData :{
        gridOptions:{ // 테이블 옵션 (같은 페이지에 있을때 공유해서 쓰면 에러)
          context: {
              componentParent: this
          },
          onGridReady: function (event) {
          },
          frameworkComponents : {
            btnSelect : BtnSelect
          }
        },
        columnDefs : [
          {headerName: '선택', field: 'id', filter: false,width: 100,
            cellRendererParams: {
              clicked: function(data) {
                let artist = this.context.componentParent.selectTrackArtist
                let artistFound = artist.find(element => element.id == data.id);
                let list = this.context.componentParent.selectFeaturingArtist
                let found = list.find(element => element.id == data.id);
                if(artistFound == undefined) {
                  if(found == undefined) {
                    this.context.componentParent.selectFeaturingArtist.push(data)
                  }else{
                    this.context.componentParent.alert({msg: '이미 선택된 아티스트입니다.'})
                  }  
                }else{
                  this.context.componentParent.alert({msg: '트랙 아티스트에 등록된 아티스트입니다.'})
                  return false
                }
                //this.context.componentParent.closeModal('artist')
              }
            },
            cellRenderer: 'btnSelect'
          },
          {headerName: '아티스트명', field: 'display_name', filter: false,width: 250,
          cellRenderer: (data) => {
              if(data.data.profile['thumbnail']){
                  return `<img class="artistTableImg" src="${data.data.profile['thumbnail']['remote_path']}"/>` + data.value
              }else{
                  return `<img class="artistTableImg" src="${data.data.profile['remote_path']}"/>` + data.value
              }
          }},
          {headerName: '아티스트명(번역)',  field: 'display_name_english',  filter: false,width: 250},
          {headerName: '등록일',      field: 'created_at',     filter: false,width: 200,
          cellRenderer: (data) => {
            return this.fixDate(data.value, 'yyyy-MM-dd HH:mm:ss')
          }},
        ],
      },
      //contributor_v2
      selectContributor : {},
      roleValue : null,
      instValue : null,
      contributorV2NameEdit: { id: null, name: null, name_multilang: {}, name_export: {}, id_external: [] },
      contributorV2ExternalOptions: ['spotify', 'apple', 'melon'],
      contributorV2ExternalType: 'spotify',
      contributorV2ExternalValue: null,
      contributorV2AppleOptions: [],
      contributorV2AppleSelected: null,
      contributorV2AppleLoading: false,
      contributorV2AppleTimer: null,
      contributorV2AppleDirectInput: false,
      contributorV2SpotifyOptions: [],
      contributorV2SpotifySelected: null,
      contributorV2SpotifyLoading: false,
      contributorV2SpotifyTimer: null,
      contributorV2SpotifyDirectInput: false,
      // Apple Music fields
      is_classical: false,
      apple_dj_mix: false,
      apple_compilation: false,
      apple_live: false,
      apple_cleared_fitness_plus: false,
      apple_available_immersive_date: null,
      // Album contributors (classical)
      albumContributors: [],
      showAlbumContributorModal: false,
      albumContributorSearch: '',
      albumContributorSearchResults: [],
      albumContributorSelectItem: null,
      albumContributorRoles: [],
      albumContributorInstruments: [],
      albumContributorIsPrimary: false,
      editingAlbumContributor: null,
      // Album works (classical)
      albumWorks: [],
      showAlbumWorkModal: false,
      editingAlbumWork: null,
      albumWorkForm: { work_name: '', work_type: '', sequence_nr: 0 },
      workTypeOptions: [
        { value: 'Symphony', label: 'Symphony' },
        { value: 'Concerto', label: 'Concerto' },
        { value: 'Sonata', label: 'Sonata' },
        { value: 'Suite', label: 'Suite' },
        { value: 'Other', label: 'Other' },
      ],
    }
  },
  mounted(){
 
   this.$nextTick((vue) =>{
      if(this.$route.params){
        this.datacall();
        this.managerCall()
        this.getGenreList()
        this.getMemoList();
        this.loadPresetOptions();
       
      }
    })
  },
  watch:{
    'contributorV2ExternalType'() {
      this.contributorV2ExternalValue = null
      this.contributorV2AppleSelected = null
      this.contributorV2AppleOptions = []
      this.contributorV2AppleDirectInput = false
      this.contributorV2SpotifySelected = null
      this.contributorV2SpotifyOptions = []
      this.contributorV2SpotifyDirectInput = false
    },
    'export_contract_preset_id'(id) {
      if (id && this.presetOptions.length) {
        this.selectedPreset = this.presetOptions.find(o => o.value === id) || null
      } else if (!id) {
        this.selectedPreset = null
      }
    },
    'userList.currentPage'(){
        this.getUserList()
    },
    'artistList.currentPage'(){
        this.getArtistList()
    },
    'contractDuration'(num){ 
      if(num != '0' && this.contract.start_date){
         
        this.contract.end_date = this.fixDate(new Date(moment(this.contract.start_date).add('years',num) ))
         
      }
    },
    'contract.start_date'(){
       if(this.contractDuration != '0' && this.contract.start_date && this.contractDuration){
         this.contract.end_date = this.fixDate(new Date(moment(this.contract.start_date).add('years',this.contractDuration) ))
       }
    },
    'selectArtist'(){
      if(this.selectArtist.length > 4){
        this.alert({msg:'앨범 아티스트 선택은 최대 4명까지 가능합니다.'});
        this.selectArtist.length = 4
      }
    },
    'copyright'(){
      // this.transfer_date = null
      // this.transfer_name = null
    },
    'contract.territory'(){
      this.territory_exception = null
    },
    'errorAlbumCode.currentPage'(){
      this.matchtableAlbumCode()
    },
    'errorAlbumName.currentPage'(){
      this.matchtableAlbumName()
    },
    'errorTrackCode.currentPage'(){
      this.matchtableTrackCode()
    },
    'errorTrackName.currentPage'(){
      this.matchtableTrackName()
    },
    'video.currentPage'(){
      this.getVideoList()
    },
    'ingestionData.currentPage'(){
      this.getIngestion()
    },
    'djData.currentPage'(){
      this.getDjList()
    },
    'monitoring.currentPage'(){
      this.monitoringList()
    },
    
    'is_even_distribution'(){
      for(let i in this.contractLicensorList ){
        if(this.is_even_distribution){
          this.contractLicensorList[i].ratio = 100/this.contractLicensorList.length
        }
      }
    },
    smartlink_color_text(data){
        const root = document.querySelector(':root');
        console.log(data)
        root.style.setProperty('--preview-text-color', data);
    },
    smartlink_color_box(data){
        const root = document.querySelector(':root');
        console.log(data)
        root.style.setProperty('--preview-box-color', data);
    },
   
  },
  computed:{
    isDark() {
      const t = this.$store.state.theme
      return t === 'dark' || t === 'semi-dark'
    },
    trackContributorsDeduped() {
      const seen = new Set()
      const result = []
      for (const track of (this.trackAll || [])) {
        for (const c of (track.contributors_v2 || [])) {
          if (!seen.has(c.id)) {
            seen.add(c.id)
            result.push(c)
          }
        }
      }
      return result.sort((a, b) => a.name.localeCompare(b.name))
    },


    canGenerateDeliveryJobs() {
      const disabledStates = ['trash', 'registration_complete', 'registration_canceled', 'suspended', 'rejected']
      return !disabledStates.includes(this.albumStatus)
    },
    sortedPresetContracts() {
      if (!this.selectedPreset) return []
      return [...this.selectedPreset.contracts].sort((a, b) => {
        const nameA = a.name || (a.export_contract && a.export_contract.name) || a.export_contract_name || ''
        const nameB = b.name || (b.export_contract && b.export_contract.name) || b.export_contract_name || ''
        return nameA.localeCompare(nameB)
      })
    },
    manualDspLabels() {
      return { melon: 'Melon', bugs: 'Bugs', flo: 'FLO', vibe: 'Vibe', genie: 'Genie' }
    },
    display_artist_album(){
      let text = ''
      for(var j in this.selectArtist){
        if(this.selectArtist[j].display_name){
          if(j != 0 ){
            text += ', '  
          }
          text += this.selectArtist[j].display_name
        }
      }
      text += ' - ' +this.name
      return text
    },
    sumRatio(){
      let num = 0
      
      for(let i in this.contractLicensorList) {
        
          if(Number(this.contractLicensorList[i].ratio)  ){
            num = Number(num) + Number(this.contractLicensorList[i].ratio)
          }
          
      }
      return num.toFixed(1)
    },
    getEntersCount() {
      var text = this.linkText,
          enters = text.split(/\r|\r\n|\n/),
          count = enters.length;
      if( count > 5){
        return true;
      }else{
        return false;
      }
      
    }
  },
  methods: {
    managerCall(){
        this.loadingShow()
        const option = {
            sort: 'admin_nickname',
            sortorder: 'asc',
            page: 0 ,
            limit: 100,
        }
        option['state'] = 'verified'
        option['role'] = 'admin'
        this.$store.dispatch('GETUSER', option)
        .then(result =>{
          this.loadingHide()
            this.managerList = [
                ...result.items
              
            ]
        }).catch(error=>{
            this.loadingHide()
            const status = error.response.status
            switch(status){
                case 401:
                this.$store.dispatch('TOKEN_ITEM_CLEAR').then(()=>{this.$router.push('/login')})
                break;
                default:
                this.alert({msg:error.response.data.message })
                break;
            }
        })
    },
    fileDown(path){
      const download = (e) => {
        // Remote URL for the file to be downloaded
        const url = path;
        const filename = this.name + "-Cover.jpg";
        $api({ method: 'post', url,data :  {},
      headers: { 
      'Access-Control-Allow-Origin' : '*',
      'Access-Control-Allow-Methods' : 'GET,PUT,POST,DELETE,PATCH,OPTIONS',
      }, responseType: 'blob' })
        .then(result =>{
          const blobURL = URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = blobURL;
            a.style.display = 'none';
    
            if (filename && filename.length) a.download = filename;
            document.body.appendChild(a);
            
          a.click();
        })
        
      };
      download();
    },
    datacall(){
      let payload = {
        id : `${this.$route.params.id}`
      }
      this.$store.dispatch('GET_ALBUM_V2', payload)
        .then(result =>{
            let t = result.data;
            this.sr_representative = t.sr_representative
            this.transcoding_in_progress = t.transcoding_in_progress
            this.selectLicensor = [{
              ...t.licensor.user,
              licensor : t.licensor
            }]
            this.name_multilang  = t.name_multilang
            this.name_export = t.name_export
            this.release_type = t.release_type
            this.source = t.source
            if(t.source == 'sftp_bulk' || t.source =='sftp-bulk')(
              this.source = 'sftp-bulk'
            )
            


            this.albumStatus = t.state
            this.copyright = t.copyright_type
            this.distributor = t.distributor
            this.explicit  = t.explicit 
            
            this.name = t.name
            this.name_language = t.name_language 
            this.name_english = t.name_english 
            this.cline_text = t.cline_text 
            this.cline_year = t.cline_year ? String(t.cline_year) : null
            this.pline_text = t.pline_text
            this.pline_year = t.pline_year ? String(t.pline_year) : null
            this.description = t.description
            
            this.description_language = t.description_language
            this.description_english = t.description_english

            this.credit = t.credit 
            this.release_version = t.release_version
            this.smartlink_url = t.smartlink_url
            this.smartlink_id = t.smartlink_id

            this.smartlink_ref = t.smartlink_ref
            this.smartlink_type =  t.smartlink_type
            this.smartlink_video_main_url =  t.smartlink_video_main_url
            this.smartlink_video_sub_url =  t.smartlink_video_sub_url
            this.smartlink_color_box =  t.smartlink_color_box
            this.smartlink_color_text =  t.smartlink_color_text
            this.smartlink_description =  t.smartlink_description





            this.youtube_cid = t.youtube_cid
            this.youtube_sr = t.youtube_sr
            this.youtube_at = t.youtube_at
            this.album_ref = t.album_ref
            this.barcode = t.barcode
            this.has_mv = t.has_mv
            this.contract= t.contract ? t.contract : {
              service_fee_other :t.licensor.default_service_fee_other,
              service_fee_kr :t.licensor.default_service_fee_kr,
              territory : null,
              territory_exception : null,
              territory_exception_v2 : [],
              start_date : null,
              end_date : null,
            }
            this.contract.start_date = t.contract.start_date ? this.fixDate(t.contract.start_date) : null
            this.contract.end_date = t.contract.end_date ? this.fixDate(t.contract.end_date) : null

            this.country = t.country
            this.desired_release_date = t.desired_release_date
            this.release_date = t.release_date
            this.release_time = t.release_time
            this.original_release_date = t.original_release_date
            this.transfer_name = t.transfer_company
            this.transfer_date = t.transfer_date
            this.videoCount = t.video_count
            this.coverimage = t.coverimage
            if(t.coverimage_id){
              this.file1 = { ...t.coverimage, preview : t.coverimage.thumbnail.remote_path}
              this.files1 = []
            }

            if(t.labelimage_id){
              this.file2 = { ...t.labelimage, preview : t.labelimage.remote_path}
              this.files2 = []
            }
            
            this.label = t.label
            this.label_english = t.label_english
            this.label_language = t.label_language
            this.is_classical = !!t.is_classical
            this.apple_dj_mix = !!t.apple_dj_mix
            this.apple_compilation = !!t.apple_compilation
            this.apple_live = !!t.apple_live
            this.apple_cleared_fitness_plus = !!t.apple_cleared_fitness_plus
            this.apple_available_immersive_date = t.apple_available_immersive_date || null
            this.albumContributors = t.album_contributor_v2 || []
            this.albumWorks = t.album_work || []
            if (this.is_classical) {
              this.getAlbumWorks()
              this.getAlbumContributors()
            }

            if(t.tags)this.tags = t.tags
            if(t.tags_v2)this.tags_v2 = t.tags_v2


            this.selectGenre = []
            this.rejectList.listData =  t.rejections
            if(t.genre1_id) {
              this.selectGenre.push(t.genre1)
            }

            if(t.genre2_id) {
              this.selectGenre.push(t.genre2)
            }

            this.selectArtist = t.artists
        
            const track = []
            const numbering = [];
            this.trackAll = t.tracks
            for(var i in t.tracks){
              if(numbering.indexOf(t.tracks[i].volume-1) > -1){
                track[numbering.indexOf(t.tracks[i].volume-1)].push(t.tracks[i])
              }else{
                numbering.push(t.tracks[i].volume-1)
                track.push([t.tracks[i]])
                 
              }
            }
            this.trackList = track
            if(this.trackList.length ==  0 ) {
              this.trackList = [[]]
            }
            const assign = {}
            for(const tr of (t.tracks || [])){
              assign[tr.id] = { work_id: tr.album_work_id || null, movement_nr: tr.movement_nr || null }
            }
            this.trackWorkAssign = assign
            this.licensor_message = t.licensor_message
            this.export_contract_preset_id = t.export_contract_preset_id || null
            this.export_contract_preset_code = t.export_contract_preset?.code || null
            this.export_contract_preset_name = t.export_contract_preset?.name || null

            this.contractFile = t.contract_file

            let artists  = []

            for(let a in t.artists){
              artists.push(t.artists[a].display_name)
            }
            this.artistText = artists.join(', ')
            this.motionart11 = t.motionart11
            this.motionart11_id = t.motionart11_id
            this.motionart34 = t.motionart34
            this.motionart34_id = t.motionart34_id

            this.code_generation_in_progress = t.code_generation_in_progress


            this.$EventBus.$emit('headerSet',{
              title : `${this.name} ${this.album_ref? ' / '+this.album_ref+'' : '  '} ${this.barcode ? ' / '+ this.barcode : ''}`,
              subTitle : `발매일 : ${this.release_date? this.release_date + ' ' +this.release_time :'-'} / 아티스트 :  ${artists.join(', ')}   `
            })

            this.loadingHide();
        }).catch(error=>{
          const status = error.status
          switch(status){
              case 401:
              this.$store.dispatch('TOKEN_ITEM_CLEAR').then(()=>{this.$router.push('/login')})
              break;
              default:
                this.alert({msg:error})
              break;
          }
      })
    },
    downloadItem ( item ) {
      const axiosApi = axios.create({
        timeout: 600000,
        headers: {
          'Content-Type':item.mimetype,
          'Access-Control-Allow-Origin': '*',
          'Access-Control-Allow-Credentials': '*'
        },
      })
       axiosApi({
          method: "get",
          url: item.remote_path,
          responseType: 'blob'
        }).then(response => {
          const blob = new Blob([response.data])
          const link = document.createElement('a')
          link.href = URL.createObjectURL(blob)
          link.download = item.display_name
          link.click()
          URL.revokeObjectURL(link.href)
        }).catch(error=>{
            console.log(error)
           
        })
    },
    getGenreList(){
      this.$store.dispatch('GET_GENRE')
      .then(result =>{
          this.genreOption  = result.items // 권리자 목록
      }).catch(error=>{
          const status = error.response.status
          switch(status){
            case 401:
            this.$store.dispatch('TOKEN_ITEM_CLEAR').then(()=>{this.$router.push('/login')})
            break;
            default:
            break;
          }
      })
    },
    //Licensor 매칭
    selectLicensorData (data){
      for(let i in this.contractLicensorList){
        if(this.contractLicensorList[i].licensor_id ==  data.licensor.id){
          this.alert({msg : '이미 선택된 라이센서 입니다.'})
          return false
        }
      }
      this.contractLicensorList.push({
        licensor : {
          ...data.licensor,
          user:{email: data.email}
        },
        licensor_id: data.licensor.id,
        ratio: 0
      })
      this.closeModal('licensor')

      
    },
    openLicensor(){
      
      this.keywordType = {label:'권리자명', value:'_name'},
      this.licensorKeyword = '',
      this.openModal('licensor');
      this.getUserList()
    },
    getUserList(){
      const option = {
        sort: 'created_at',
        sortorder: 'desc',
        role : 'licensor',
        page: this.userList.currentPage-1 ,
        limit: this.userList.pageSize
      }
      if(this.keywordType && this.keywordType !='') {
          option[this.keywordType.value] = this.licensorKeyword
      }
      this.loadingShow()
      this.$store.dispatch('GETUSER', option)
      .then(result =>{
          this.loadingHide()
          this.userList.listData  = result.items // 권리자 목록
          //페이지 수
          const remainder = parseInt(result.filtered % this.userList.pageSize) > 0? 1: 0
          this.userList.totalPage = parseInt(result.filtered /this.userList.pageSize) + remainder
      }).catch(error=>{
          const status = error.response.status
          switch(status){
            case 401:
            this.$store.dispatch('TOKEN_ITEM_CLEAR').then(()=>{this.$router.push('/login')})
            break;
            default:
            break;
          }
      })
    },
    //Artist 매칭
    openArtist(){
      if(this.selectLicensor.length == 0) {
        this.alert({msg:'Licensor 매칭을 해주세요.'})
        
        return false;
      }
      this.artistList =  {
        listData: [],                 
        pageSize: 5,                 
        currentPage: 1,
        totalPage: 0,                
      },
      this.artistKeywordType = {value: 'display_name', label: '아티스트명'},
      this.artistKeyword = null,
      this.openModal('artist');
      this.getArtistList()
      this.getArtistVarious()
    },
    removeArtist(index){
      this.selectArtist.splice(index, 1)
      this.variousArtistStatus = false
    },
    removeTrackArtist(index){
      this.selectTrackArtist.splice(index, 1)
      this.variousArtistStatus = false
    },
    getArtistList(){
        const option = {
        licensor_id : this.selectLicensor[0].licensor.id,
        params :{
          sort: 'created_at',
          sortorder: 'desc',
          page: this.artistList.currentPage-1 ,
          limit: this.artistList.pageSize,
          is_various_artists: false,
        }
      }
      if(this.artistKeywordType && this.artistKeywordType !='') {
          option.params[this.artistKeywordType.value] = this.artistKeyword
      }
      this.$store.dispatch('GET_LICENSOR_ARTIST', option).then(result =>{
          
          this.artistList.listData  = result.items // 권리자 목록
          //페이지 수
          const remainder = parseInt(result.filtered % this.artistList.pageSize) > 0? 1: 0
          this.artistList.totalPage = parseInt(result.filtered /this.artistList.pageSize) + remainder
      }).catch(error=>{
          const status = error.response.status
          switch(status){
            case 401:
            this.$store.dispatch('TOKEN_ITEM_CLEAR').then(()=>{this.$router.push('/login')})
            break;
            default:
            break;
          }
      })
    },
    // Various artist
    getArtistVarious(){
      const option = {
        licensor_id : this.selectLicensor[0].licensor.id,
        params :{
          page: 0 ,
          is_various_artists: true,
        }
      }
      this.$store.dispatch('GET_LICENSOR_ARTIST', option).then(result =>{
          if(result.items.length == 0) {
            this.alert({msg:'Various 아티스트가 존재하지 않습니다. 개발팀에게 문의해주세요.'})
            this.closeModal('artist')
          }
          this.variousArtist  = result.items[0] // 권리자 목록
      }).catch(error=>{
          const status = error.response.status
          switch(status){
            case 401:
            this.$store.dispatch('TOKEN_ITEM_CLEAR').then(()=>{this.$router.push('/login')})
            break;
            default:
            break;
          }
      })
    },
    
    albumVarious(e){
      if(e.target.checked){
        this.selectArtist = [this.variousArtist]
      }else{
        this.selectArtist = []
      }
    },
    // 트랙 등록
    openTrack(name, index){
      this.trackModalMode = 'save'
      if(this.selectLicensor.length == 0) {
        this.alert({msg:'Licensor 매칭을 해주세요.'})
        
        return false;
      }
      this.files3 = []
      this.files5 = []
      this.trackDetail = {
        ...this.trackTemplate,
        volume : index + 1,
        tracknr : this.trackList[index].length + 1
      }
   
      this.trackDetail.contributors.splice(0)
      this.selectTrackArtist = [...(this.selectArtist || [])]
      this.trackGenre = [...(this.selectGenre || [])]
      this.selectFeaturingArtist = []
      this.showPreviewPicker = false
      if(this.selectTrackArtist.length > 0 && this.selectTrackArtist[0].is_various_artists){
        this.variousTrackArtistStatus = true
      }else{
        this.variousTrackArtistStatus = false
      }
      this.openModal('track')
    },
    openAudio(index,indextr){
      let file = [...(this.trackList[index][indextr].files || [])]
      // 크롬 미지원 및 용량에 따른 재생 불가능으로 삭제
      // if(this.trackList[index][indextr].dolbyatmos){
      //   file.push({
      //     ...this.trackList[index][indextr].dolbyatmos,
      //     display_name: 'Dolby Atmos',
      //     artist: '',
      //     url: this.trackList[index][indextr].dolbyatmos.remote_path,
      //     cover: 'ddd', 
      //   })
      // }
      this.audioList = []
      for(var i in file){
        this.audioList.push(
          {
            ...file[i],
            name: file[i].display_name,
            artist: '',
            url: file[i].remote_path,
            cover: 'ddd', 
          }
        )
      }
      console.log(this.audioList)
      this.openModal('audio')
      this.$forceUpdate()
    },
    
    openLyrics(index,indextr){
      this.trackDetail = this.trackList[index][indextr]
      this.openModal('lyrics')
    },
    test : (data)=>{
      return data
    },
    editTrack(index,indexTr,data){
      this.trackModalMode = 'edit'
      let trackData = JSON.parse(JSON.stringify(data));
      console.log(trackData)
      this.trackDetail = this.test({
          ...trackData,
          contributors: trackData.contributors ?? [],
          contributors_v2: Array.isArray(trackData.contributors_v2) ? trackData.contributors_v2 : [],
          volume :  index + 1,
          tracknr : indexTr + 1,
      })
      const arr = Object.freeze([
          "composer",
          "lyricist",
          "arranger",
          "producer",
          "publisher",
          "remixer",
          "conductor",
          "choir",
          "orchestra",
          "translator",
          "narrator",
          "studio_musician",
          "studio_personnel",
      ])
      if(this.trackDetail.contributors){
        this.trackDetail.contributors.sort(function(a,b){
            if(arr.indexOf(a.role)  < arr.indexOf(b.role))
            return -1;
            if(arr.indexOf(a.role)  > arr.indexOf(b.role))
            return 0;
        })  
      }
      
      
      this.files3 = []
      for(var i in this.trackDetail.files){
        this.files3.push({
          ...this.trackDetail.files[i],
          response : [{
            ...this.trackDetail.files[i]
          }],
          progress : 100
        })
      }
      
      this.files5 = []
      if(this.trackDetail.dolbyatmos){
        this.files5 = [{
          ...this.trackDetail.dolbyatmos,
          response : [{
            ...this.trackDetail.dolbyatmos
          }],
          progress : 100
        }]
      }

      this.files6 = []
      if(this.trackDetail.appledigitalmaster){
        this.files6 = [{
          ...this.trackDetail.appledigitalmaster,
          response : [{
            ...this.trackDetail.appledigitalmaster
          }],
          progress : 100
        }]
      }

      this.selectTrackArtist = trackData.artists ?? []
      this.selectFeaturingArtist = trackData.featuring_artists_v2 ?? []
      this.trackGenre = []
      if(!this.valCheck(trackData.genre1_id)){
        this.trackGenre.push(trackData.genre1)
      }
      if(!this.valCheck(trackData.genre2)){
        this.trackGenre.push(trackData.genre2)
      }
      if(this.selectTrackArtist.length > 0 &&  this.selectTrackArtist[0].is_various_artists){
        this.variousTrackArtistStatus = true
      }else{
        this.variousTrackArtistStatus = false
      }
      this.showPreviewPicker = false

      this.openModal('track')
    },
    saveTrack(){
      if(this.valCheck(this.trackDetail.name)){
        this.alert({msg : '트랙명을 입력해주세요.'})
        return false
      }
      this.loadingShow()
      this.trackDetail.files = []
      for(var i in this.files3){
        this.trackDetail.files.push({id:this.files3[i].response[0].id })
      }

      this.trackDetail.artists = []
      for(var a in this.selectTrackArtist){
          this.trackDetail.artists.push({id:this.selectTrackArtist[a].id})
      }

      this.trackDetail.featuring_artists_v2 = []
      for(var a in this.selectFeaturingArtist){
          this.trackDetail.featuring_artists_v2.push({id:this.selectFeaturingArtist[a].id})
      }

      if(this.files5.length > 0){
        this.trackDetail.dolbyatmos_id = this.files5[0].response[0].id
      }else{
        this.trackDetail.dolbyatmos_id = null
      }

      if(this.files6.length > 0){
        this.trackDetail.appledigitalmaster_id = this.files6[0].response[0].id
      }else{
        this.trackDetail.appledigitalmaster_id = null
      }
      
      delete this.trackDetail.genre1
      delete this.trackDetail.genre2
      delete this.trackDetail.track_ref

      this.trackDetail.genre1_id =null
      this.trackDetail.genre2_id = null 
      
      for(var b in this.trackGenre){
        if(this.trackGenre[b]){
          if(b == 0){
            this.trackDetail.genre1_id = this.trackGenre[b].id
          }else{
            this.trackDetail.genre2_id = this.trackGenre[b].id
          }
        }
      }
      
      if(this.trackDetail.type == 'etc'){
          
      }else{
        this.trackDetail.alt_type = null
      }
      if(this.trackDetail.explicit){
        this.trackDetail.parental_warning = "explicit"
      }else{
        this.trackDetail.parental_warning = "not_explicit"
      }
      for (const key in this.trackDetail.name_multilang) {
          if(this.valCheck(this.trackDetail.name_multilang[key]) ){
            delete this.trackDetail.name_multilang[key]
          }else{
          }
      }
      for (const key in this.trackDetail.name_export) {
          if(this.valCheck(this.trackDetail.name_export[key]) ){
            delete this.trackDetail.name_export[key]
          }else{
          }
      }
      
      const payload = {
        id : this.$route.params.id,
        params : this.trackDetail
      }
      
      delete payload.params.dolbyatmos
      delete payload.params.isrc
      delete payload.params.dolbyatmos_isrc

      if(this.trackModalMode =='edit'){
        this.$store.dispatch("PUT_ALBUM_TRACK_V2", payload)
        .then(result =>{
          outer: for (let i = 0; i < this.trackList.length; i++) {
            for (let j = 0; j < this.trackList[i].length; j++) {
              if (String(this.trackList[i][j].id) === String(result.id)) {
                this.$set(this.trackList[i], j, result)
                break outer
              }
            }
          }
          this.loadingHide();
          this.noti('트랙 편집을 성공하였습니다.')
          this.stopPreview()
          this.closeModal('track')
        }).catch(error =>{
          this.loadingHide();
          switch(error.response.data.code) {
            default:
              this.alert({msg:error})
              break;
          }
        })
      }else{
        this.$store.dispatch("POST_ALBUM_TRACK_V2", payload)
        .then(result =>{
          this.noti('트랙 추가를 성공하였습니다.')
          const volumeIndex = this.trackDetail.volume - 1
          this.trackList[volumeIndex].push(result)
          this.trackNumberingSave()
          this.closeModal('track')
        }).catch(error =>{
          this.loadingHide();
          switch(error.response.data.code) {
            default:
              this.alert({msg:error})
              break;
          }
        })
      }
      
      
    },

    trackVarious(e){
      
      if(e.target.checked){
        this.selectTrackArtist = [this.variousArtist]
      }else{
        this.selectTrackArtist = []
      }
    },

    removeVolume(index){
      
      this.trackList.splice(index , 1)
    },
    removeTrackConfirm(vol,index){
      this.selectData =  JSON.parse(JSON.stringify(this.trackList[vol][index]));
      this.confirm({
        title :'트랙 삭제 확인', 
        msg :`<div>선택하신 트랙을 삭제하시겠습니까?<div>
              <div>삭제된 정보는 취소하거나 되돌릴 수 없습니다.<div>
        `,
        action : ()=>{
          this.removeTrack(vol,index)
        }
       })
      
    },
    removeTrack(vol,index){
      
      
      this.loadingShow();
      const payload = {
        id : this.selectData.album_id,
        track_id :this.selectData.id
      }
      this.trackList[vol].splice(index,1)
       
      this.$store.dispatch('DELETE_ALBUM_TRACK', payload)
      .then(result =>{
        this.noti('삭제되었습니다.')
        this.trackNumberingSave()
        this.closeModal('removeTrackConfirm')
        
      }).catch(error=>{
        this.loadingHide();
        const status = error.response.status
        switch(status){
          case 401:
          this.$store.dispatch('TOKEN_ITEM_CLEAR').then(()=>{this.$router.push('/login')})
          break;
          default:
          break;
        }
      })
    },
    openTrackArtist(){
      if(this.selectLicensor.length == 0) {
        this.alert({msg:'Licensor 매칭을 해주세요.'})
        return false;
      }
      this.artist =  {
        listData: [],                 
        pageSize: 0,                 
        currentPage: 1,
        totalPage: 0,                
      },
      this.artistKeywordType = {value: 'display_name', label: '아티스트명'},
      this.artistKeyword = null,
      this.openModal('trackArtist');
      this.getArtistList()
      this.getArtistVarious()
    },
    removeTrackArtist(index){
      this.selectTrackArtist.splice(index, 1)
      this.variousTrackArtistStatus = false
    },
    openFeaturingArtist(){
      if(this.selectLicensor.length == 0) {
        this.alert({msg:'Licensor 매칭을 해주세요.'})
        return false;
      }
      this.artist =  {
        listData: [],                 
        pageSize: 0,                 
        currentPage: 1,
        totalPage: 0,                
      },
      this.artistKeywordType = {value: 'display_name', label: '아티스트명'},
      this.artistKeyword = null,
      this.openModal('featuringArtist');
      this.getArtistList()
 
    },
    removeFeaturingArtist(index){
      this.selectFeaturingArtist.splice(index, 1)
    },
    getGenreList(){
      this.$store.dispatch('GET_GENRE')
      .then(result =>{
          this.genreOption  = result.items // 권리자 목록
      }).catch(error=>{
          const status = error.response.status
          switch(status){
            case 401:
            this.$store.dispatch('TOKEN_ITEM_CLEAR').then(()=>{this.$router.push('/login')})
            break;
            default:
            break;
          }
      })
    },
    // 앨범 이미지
    inputFileUpload1(newFile, oldFile) {
        if (newFile && !oldFile) {
          // add
          
          if(newFile.type.indexOf('image') < 0 ){
            this.alert({msg:'이미지만 등록 가능합니다.'})
            return false
          }
          let file = newFile.file
          let reader = new FileReader
          this.loadingShow()
          reader.onload = e => {
            let img = new Image()
            img.src = e.target.result
            img.onload = () =>{
              let imgWidth = img.width
              let imgHeight = img.height
             
              if(imgHeight !=  imgWidth ){
                this.loadingHide()
                this.alert({msg:'1:1 비율만 등록 가능합니다.'})
                this.files1 = []
                return false
              }
              this.$refs.upload1.active = true
              this.file1.preview = e.target.result
            }
          }
          reader.readAsDataURL(file)
        }
        if (newFile && oldFile) {
          // update
          console.log(newFile)
          if(Array.isArray(newFile.response)){
            this.file1 ={
              ...this.file1,
              ...newFile.response[0]
            }
            console.log(this.file1)
            this.loadingHide()
          }
          if(!newFile.active){
            this.loadingHide();
          }
        }
        if (!newFile && oldFile) {
          // remove
          console.log('remove', oldFile)
        }
      },
    //기획사 이미지
    inputFileUpload2(newFile, oldFile) {
      if (newFile && !oldFile) {
        // add
        if(newFile.type.indexOf('image') < 0 ){
          this.alert({msg:'이미지만 등록 가능합니다.'})
          return false
        }
        this.$refs.upload2.active = true
        let file = newFile.file
        let reader = new FileReader
        reader.onload = e => {
          this.file2.preview = e.target.result
        }
        reader.readAsDataURL(file)
      }
      if (newFile && oldFile) {
        // update
        if(Array.isArray(newFile.response)){
          this.file2 ={
            ...this.file2,
            ...newFile.response[0]
          }
        }
        
      }
      if (!newFile && oldFile) {
        // remove
        
      }
    },
    //트랙 파일
    inputFileUpload3(newFile, oldFile) {
      
      if (newFile && !oldFile) {
        // add
        this.$refs.upload3.active = true
        
      }
      if(newFile.xhr){
          if(newFile.xhr.status == 401){
              this.alert({msg:'cut'})
              return false;
          }
      }
      if (newFile.active && oldFile.active) {
        // update
        if(newFile.type.indexOf('audio') < 0 ){
          this.alert({msg:'오디오(mp3,wav,flac) 파일만 가능합니다.'});
          this.$refs.upload3.remove(newFile)
          return false
        }
        if(newFile.progress == '100.00' ){
          this.loadingHide()
        }
        if(newFile.progress == '0.00' ){
          this.loadingShow();
        }
      }
      
      if (!newFile && oldFile) {
        // remove
        //console.log('remove', oldFile)
      }
    },
       
    
    addVolume(){
      this.trackList.push([])
    },
    removeFile(index){
      this.deleteAudio(this.files3[index].id)
      this.files3.splice(index,1);
    },
    deleteAudio(id){
      this.loadingShow();
      const payload = {
        album_id : this.$route.params.id,
        track_id : this.trackDetail.id,
        id : id
      }
      this.$store.dispatch("DELETE_AUDIO_FILE", payload)
      .then(result => {
        this.loadingHide();
        this.noti('삭제되었습니다.')
        this.datacall();
      }).catch(error=>{
        this.loadingHide();
        switch(error.response.data.code) {
          default:
            this.alert({msg:error})
            break;
        }
      })
    },
    
    addContributor(){
      if(this.valCheck(this.contributorsRole)){
        this.noti({msg:'참여자 구분을 선택해주세요.'})
        return false
      }
      if(this.valCheck(this.contributorsName)){
        this.alert({msg:'참여자 이름을 입력해주세요.'})
        return false
      }
      this.trackDetail.contributors.push({
        name : this.contributorsName,
        role : this.contributorsRole,
        copyright_association : this.contributorsCompany,
        ipi : this.contributorsIpi
      })
      const arr = Object.freeze([
          "composer",
          "lyricist",
          "arranger",
          "producer",
          "publisher",
          "remixer",
          "conductor",
          "choir",
          "orchestra",
          "translator",
          "narrator",
          "studio_musician",
          "studio_personnel",
      ])
      this.trackDetail.contributors.sort(function(a,b){
          if(arr.indexOf(a.role)  < arr.indexOf(b.role))
          return -1;
          if(arr.indexOf(a.role)  > arr.indexOf(b.role))
          return 0;
      })
      this.contributorsName = this.contributorsCompany = null
      this.contributorsIpi = null
      this.$forceUpdate()
    },
    removeContributor(index){
      this.trackDetail.contributors.splice(index,1)
    },
    //기본정보 저장 - 트랙 제외
    all_save(){
      this.closeModal('confirm')
      if(this.selectLicensor.length < 1) {
        this.alert({msg:'Licensor 매칭을 해주세요.'});
        return false
      }

      if(this.valCheck(this.name)){
        this.alert({msg:'앨범명을 입력해주세요.'});
        return false
      }

      if(this.valCheck(this.release_type)){
        this.alert({msg:'앨범유형을 선택해주세요.'});
        return false
      }

      if(this.valCheck(this.contract.territory)){
        this.alert({msg:'발매 뮤직스토어를 선택해주세요.'});
        return false
      }
      if(this.valCheck(this.contract.start_date)){
        this.alert({msg:'계약 시작일을 선택해주세요.'});
        return false
      }
      for (const key in this.name_multilang) {
          if(this.valCheck(this.name_multilang[key]) ){
            delete this.name_multilang[key]
          }else{
          }
      }
      for (const key in this.name_export) {
          if(this.valCheck(this.name_export[key]) ){
            delete this.name_export[key]
          }else{
          }
      }
      if(!this.valCheck(this.release_date)){
        console.log(this.release_date)
        if(this.valCheck(this.cline_year)){
          this.cline_year = this.fixDate(this.release_date,'yyyy')
        }
        if(this.valCheck(this.pline_year)){
          this.pline_year = this.fixDate(this.release_date,'yyyy')
        }
      }
      let payload = {
        id : `${this.$route.params.id}`,
        params : {
          release_type: this.release_type,
          source: this.source,
          state: this.albumStatus,
          copyright_type: this.copyright,
          distributor: "Sound Republica, Inc.",
          barcode : this.barcode,
          name: this.name,
          name_language : this.name_language,
          name_english : this.name_english,
          name_multilang : this.name_multilang,
          name_export : this.name_export,
          release_version : this.release_version,

          cline_text : this.cline_text,
          cline_year : this.cline_year ? Number(this.cline_year) : null,
          pline_text: this.pline_text,
          pline_year : this.pline_year ? Number(this.pline_year) : null,

          description: this.description,
          description_language: this.description_language,
          description_english: this.description_english,
          credit : this.credit,
          
          youtube_cid: this.youtube_cid,
          youtube_sr : this.youtube_sr,
          youtube_at : this.youtube_at,
          genre1_id : this.selectGenre[0] ? this.selectGenre[0].id :null,
          genre2_id : this.selectGenre[1] ? this.selectGenre[1].id : null,
          
          contract : this.contract,
          label : this.label,
          label_english : this.label_english,
          label_language : this.label_language,
          is_classical: this.is_classical,
          apple_dj_mix: this.apple_dj_mix,
          apple_compilation: this.apple_compilation,
          apple_live: this.apple_live,
          apple_cleared_fitness_plus: this.apple_cleared_fitness_plus,
          apple_available_immersive_date: this.apple_cleared_fitness_plus ? this.apple_available_immersive_date : null,
          country : this.country,
          desired_release_date : this.desired_release_date,
          release_date : this.release_date,
          release_time : this.release_time,
          tags : this.tags,
          tags_v2 : this.tags_v2,
          has_mv : this.has_mv,
          sr_representative : this.sr_representative
        }
      }
      
      if(!payload.params.contract.usage) delete payload.params.contract.usage
      if(!payload.params.contract.distribution_channel) delete payload.params.contract.distribution_channel
      if(!payload.params.contract.type) delete payload.params.contract.type
      
      if(this.files1.length > 0){
        payload.params['coverimage_id'] = this.file1.id
      }else{
        delete payload.params['coverimage_id']
      }
    
      if(this.files2.length > 0){
        payload.params['labelimage_id'] = this.file2.id
      }else{
       delete payload.params['labelimage_id']  
      }
      
      if(!this.valCheck(this.original_release_date)){
        payload.params['original_release_date'] = this.original_release_date
      }else{
        payload.params['original_release_date'] = null
      }
      if(this.copyright == 'transfer'){
        if(!this.valCheck(this.transfer_name)){
          payload.params['transfer_company'] = this.transfer_name
        }else{
          this.alert({msg:'양도사를 입력해주세요.'})
          return false
        }
        if(!this.valCheck(this.transfer_date)){
          payload.params['transfer_date'] = this.transfer_date
        }else{
          this.alert({msg:'양도일을 입력해주세요.'})
          return false
        }
      }else{
        payload.params['transfer_company'] = null
        payload.params['transfer_date'] = null
      }
      if (this.contract.territory == 'global' && this.contract.territory_exception =='korea') {
        payload.params.contract['territory_exception'] = 'korea'
      }else{
        payload.params.contract.territory_exception = null
      }
      if(payload.params.contract['contract_licensor']){
        delete payload.params.contract['contract_licensor']
      }
      // let trackArray = []
      // for(var i in this.trackList){
      //   if(i != 0 && this.trackList[i].length == 0){
      //     this.alert({msg:'Volume2부터는 1곡이상이 있어야합니다.'})
      //     return false
      //   }
      //   for(var j in this.trackList[i]){
      //     this.trackList[i][j].volume =  Number(i) + 1
      //     this.trackList[i][j].tracknr =  Number(j) + 1
      //     delete this.trackList[i][j].saveArtist
      //     delete this.trackList[i][j].saveFile
      //     delete this.trackList[i][j].saveGenre
      //   }
      //   trackArray = trackArray.concat(this.trackList[i])
      // }
      // payload['tracks'] = trackArray
      let artists = []
      for(var a in this.selectArtist){
        artists.push({id :this.selectArtist[a].id});
      }
      payload.params['artists'] =  artists
      payload.params['export_contract_preset_id'] = this.export_contract_preset_id || null
      this.loadingShow()
      this.$store.dispatch("PUT_ALBUM_V2", payload)
      .then(result =>{
        this.loadingHide();
        this.noti('앨범이 정상적으로 수정 되었습니다.')
        this.datacall()
      }).catch(error =>{
        this.loadingHide();
        switch(error.response.data.code) {
          default:
            this.alert({msg:error})
            break;
        }
      })
    },
    albumComplete(){
      let payload = {
        id : `${this.$route.params.id}`,
        params : {
          state: 'inspection_complete'
        }
      }
      this.loadingShow()
      this.$store.dispatch("PUT_ALBUM_V2", payload)
      .then(result =>{
        this.loadingHide();
        this.noti('검수완료 처리 되었습니다.')
        this.datacall()
      }).catch(error =>{
        this.loadingHide();
        switch(error.response.data.code) {
          default:
            this.alert({msg:error})
            break;
        }
      })
    },
    albumTagSave(){
      let payload = {
        id : `${this.$route.params.id}`,
        params : {
          genre1_id : this.selectGenre[0] ? this.selectGenre[0].id :null,
          genre2_id : this.selectGenre[1] ? this.selectGenre[1].id : null,
          contract : this.contract,
          release_date : this.release_date,
          release_time : this.release_time,
          has_mv : this.has_mv,
          tags_v2 : this.tags_v2,
        }
      }
      if (this.contract.territory == 'global' && this.contract.territory_exception =='korea') {
        payload.params.contract['territory_exception'] = 'korea'
      }else{
        payload.params.contract.territory_exception = null
      }
      if(payload.params.contract['contract_licensor']){
        delete payload.params.contract['contract_licensor']
      }
      this.loadingShow()
      this.$store.dispatch("PUT_ALBUM_V2", payload)
      .then(result =>{
        this.loadingHide();
        this.datacall()
      }).catch(error =>{
        this.loadingHide();
        switch(error.response.data.code) {
          default:
            this.alert({msg:error})
            break;
        }
      })
    },
    albumDateSave(){
      let payload = {
        id : `${this.$route.params.id}`,
        params : {
          release_date : this.release_date,
          release_time : this.release_time,
        }
      }
      this.loadingShow()
      this.$store.dispatch("PUT_ALBUM_V2", payload)
      .then(result =>{
        this.loadingHide();
        this.datacall()
      }).catch(error =>{
        this.loadingHide();
        switch(error.response.data.code) {
          default:
            this.alert({msg:error})
            break;
        }
      })
    },
    albumReject(){
      if(this.valCheck(this.rejectMemo)){
        this.alert({msg:'반려사유를 입력해주세요.'})
        return false
      }


       this.confirm({
        title :'반려 처리', 
        msg :`<div> 반려 하시겠습니까?<div>
              <div>저장하시면 권리자에게 메일 안내가 갑니다. <div>
              <div>(등록 후 수정 불가능)</div>
              
        `,
        action : ()=>{
           let payload = {
              id : `${this.$route.params.id}`,
              params : {
                message: this.rejectMemo
              }
            }
            this.loadingShow()
            this.$store.dispatch("PUT_REJECT_ALBUM", payload)
            .then(result =>{
              this.loadingHide();
              this.closeModal('reject')
              this.noti('반려처리 되었습니다.')
              this.rejectMemo = null
              this.datacall()
            }).catch(error =>{
              this.loadingHide();
              switch(error.response.data.code) {
                default:
                  this.alert({msg:error})
                  break;
              }
            })
        }
       })

     
    },

    track_all_save(){
      this.confirm({
        title:'트랙 순서 저장',
        msg: '현재 나열된 순서로 트랙 순서를 저장 하시겠습니까?',
        action:()=>{
          this.trackNumberingSave();
        }
      })
      
    },
    trackNumberingSave(){
      let payload = {
            id  : this.$route.params.id,
            params :{
              id: Number(this.$route.params.id),
            },
          }
          let trackArray = []
          for(var i in this.trackList){
            for(var j in this.trackList[i]){
              trackArray.push(
                {
                volume : Number(i) + 1,
                tracknr : Number(j) + 1,
                id : this.trackList[i][j].id 
                }
              )
              
            }
          }
          payload.params['tracks'] = trackArray
          this.loadingShow()
          this.$store.dispatch("PUT_ALBUM_V2", payload)
          .then(result =>{
            
            let t = result.data
            const track = []
            const numbering = [];
            this.trackAll = t.tracks
            for(var i in t.tracks){
              if(numbering.indexOf(t.tracks[i].volume-1) > -1){
                track[numbering.indexOf(t.tracks[i].volume-1)].push(t.tracks[i])
              }else{
                numbering.push(t.tracks[i].volume-1)
                track.push([t.tracks[i]])
              }
            }
            this.trackList = track
            if(this.trackList.length ==  0 ) {
              this.trackList = [[]]
            }

            this.datacall()
          }).catch(error =>{
            this.loadingHide();
            switch(error.response.data.code) {
              default:
                this.alert({msg:error})
                break;
            }
          })
    },

    track_all_genre(){
      let text = ''
      if(this.selectGenre[0]){
        text = this.selectGenre[0].name_english
      }
      if(this.selectGenre[1]){
        text += ', '+this.selectGenre[1].name_english
      }
      this.confirm({
        title: '앨범 아티스트 일괄 적용',
        msg : '앨범 장르('+text +')를 트랙에 일괄 적용하시겠습니까? ',
        action:()=>{
          let payload = {
            id  : this.$route.params.id,
            params :{
              id: Number(this.$route.params.id),
            },
          }
          
          let trackArray = []
          
          for(var i in this.trackList){
            for(var j in this.trackList[i]){
              trackArray.push(
                {
                  volume : Number(i) + 1,
                  tracknr : Number(j) + 1,
                  id : this.trackList[i][j].id,
                  genre1_id : this.selectGenre[0] ? this.selectGenre[0].id :null,
                  genre2_id : this.selectGenre[1] ? this.selectGenre[1].id : null
                }
              )
              console.log(trackArray)
            }
          }
            
          
          payload.params['tracks'] = trackArray
          this.loadingShow()
          
          this.$store.dispatch("PUT_ALBUM_V2", payload)
          .then(result =>{
            this.noti('트랙정보가 저장되었습니다.')
            this.datacall()
          }).catch(error =>{
            this.loadingHide();
            switch(error.response.data.code) {
              default:
                this.alert({msg:error.response.data.message})
                break;
            }
          })
        }
      })
      
    },
    track_all_artist(){
      let artists = []
      let text = ""
      for(var a in this.selectArtist){
        artists.push({id :this.selectArtist[a].id});
        text += a == 0  ? this.selectArtist[a].display_name : ','+ this.selectArtist[a].display_name
      }
      this.confirm({
        title: '앨범 아티스트 일괄 적용',
        msg : '앨범 아티스트 ('+text +')를 트랙에 일괄 적용하시겠습니까? ',
        action:()=>{
          let payload = {
            id  : this.$route.params.id,
            params :{
              id: Number(this.$route.params.id),
            },
          }
          let trackArray = []
          for(var i in this.trackList){
            for(var j in this.trackList[i]){
              trackArray.push(
                {
                  volume : Number(i) + 1,
                  tracknr : Number(j) + 1,
                  id : this.trackList[i][j].id,
                  artists : artists 
                }
              )
              
            }
          }
         
          payload.params['tracks'] = trackArray
          this.loadingShow()
          this.$store.dispatch("PUT_ALBUM_V2", payload)
          .then(result =>{
            this.noti('트랙정보가 저장되었습니다.')
            this.datacall()
          }).catch(error =>{
            this.loadingHide();
            switch(error.response.data.code) {
              default:
                this.alert({msg:error})
                break;
            }
          })
        }
      })
     
      
    },
    track_all_audio_language(){
      this.lyrics_language_all = null
      this.openModal('trackLanguage')
    },
    track_all_language(){
      
        let payload = {
          id  : this.$route.params.id,
          params :{
            id: Number(this.$route.params.id),
          },
        }
         if(this.lyrics_language_all==null){
          this.alert({msg:'오디오 언어를 선택해주세요.'})
          return false
        }
        let trackArray = []
        
        for(var i in this.trackList){
          for(var j in this.trackList[i]){
            trackArray.push(
              {
                id : this.trackList[i][j].id,
                lyrics_language : this.lyrics_language_all
              }
            )
            
          }
        }
          
        
        payload.params['tracks'] = trackArray
        this.loadingShow()
        
        this.$store.dispatch("PUT_ALBUM_V2", payload)
        .then(result =>{
          this.closeModal('trackLanguage')
          this.noti('모든 트랙의 오디오 언어가 일괄 저장되었습니다.')
          this.datacall()
          
        }).catch(error =>{
          this.loadingHide();
          switch(error.response.data.code) {
            default:
              this.alert({msg:error.response.data.message})
              break;
          }
        })
      
      
    },
    memo_save() {
      const payload = {
        role: 'album',
        id : `${this.$route.params.id}`,
        data: this.memo.memoText,
      }

      if(this.valCheck(this.memo.memoText)){
        this.alert({msg:'내용을 입력해주세요.'});
        return false;
      }

      this.$store.dispatch('POSTMEMO', payload)
      .then(result =>{
        this.memo.memoText = null
        this.getMemoList(payload)
        this.noti('메모가 추가되었습니다.')
        this.closeModal('memo')
      }).catch(error =>{
        this.loadingHide();
        switch(error.response.data.code) {
          default:
            this.alert({
              msg : error.response.data
            }) 
          break;
        }
      })
    },
    getMemoList() {

      const payload = {
        role: 'album',
        id : `${this.$route.params.id}`,
        params : {
          sort: 'created_at',
          sortorder: 'desc',
          page: this.memo.currentPage - 1,
          limit: 10
        }
      }
      this.loadingShow()
      this.$store.dispatch('GETMEMOLIST', payload)
      .then(result =>{
        this.loadingHide()
        this.memo.listData = result.data.items
        const remainder = parseInt(result.data.total % 10) > 0 ? 1: 0
        this.memo.totalPage = parseInt(result.data.total/10) + remainder

      })
    },
    memo_delete(){
      this.closeModal('removeMemo')
      if(!this.selectMemo || this.selectMemo == '' ){
        this.alert({msg: '메모를 선택해주세요.'})
        return false;
      }

      const payload = {
        role: 'album',
        id : `${this.$route.params.id}`,
        memo_id: this.selectMemo
      }

      this.$store.dispatch("DELETEMEMO", payload)
      .then(result =>{
        this.noti('메모가 삭제 되었습니다.')
        this.getMemoList()
      }).catch(error =>{
        this.loadingHide();
        switch(error.response.data.code) {
          case 1: 
            this.alert({
              msg : '권한이없습니다.'
            }) 
          break;
          default:
            this.alert({
              msg : error.response.data
            }) 
          break;
        }
      })
    },
    memo_delete2(id){
      
     this.confirm({
        title : '메모 삭제',
        msg : `
            선택하신 메모를 삭제하시겠습니까?
        `,
        action : ()=>{
            this.loadingShow()
           
            const payload = {
              role: 'album',
              id : `${this.$route.params.id}`,
              memo_id: id
            }

            this.$store.dispatch("DELETEMEMO", payload)
            .then(result =>{
              this.noti('메모가 삭제 되었습니다.')
              this.getMemoList()
            }).catch(error =>{
              this.loadingHide();
              switch(error.response.data.code) {
                case 1: 
                  this.alert({
                    msg : '권한이없습니다.'
                  }) 
                break;
                default:
                  this.alert({
                    msg : error.response.data
                  }) 
                break;
              }
            })
        }
      })
      
      
    },
    uciGenerateConfirm () {
      let trackListInfo = []
      for(var i in this.trackList){
        trackListInfo = trackListInfo.concat(this.trackList[i])
      }
      if (trackListInfo.length === 0) {
        
        this.alert({msg : '앨범에 등록되어있는 트랙이 없습니다.'})
        return false
      }

      let targetCount = 0
      let alreadyUci = true

      trackListInfo.forEach((track) => {
        if (!track.uci) {
          alreadyUci = false
          targetCount += 1
        }
      })

      if (alreadyUci) {
        this.alert({msg : '모든 트랙에 UCI코드가 존재합니다.'})
        return false
      }
      this.confirm({
        title :'UCI CODE 발급', 
        msg :`<div> <div><b>UCI코드가 없는 ${targetCount} 개 트랙에 대해 UCI코드를 발급하시겠습니까?</b></div> <div>필수값 정보가 모두 있는 지 상세정보를 먼저 확인해주세요</div>
        <div>발급된 UCI코드는 트랙 상세정보에서 확인할 수 있습니다.</div>
        <div>[UCI코드 발급 필수값]</div>
        <div class="swalBold">자사앨범코드, 앨범명, 앨범아티스트명, 발매일, 유통사</div>
        <div class="swalBold">국가코드(권리자국가), 제작사(앨범기획사), UPC, 자사트랙코드</div>
        <div class="swalBold">트랙명, Volume번호, 트랙번호, 트랙아티스트명</div>
        `,
        action : this.postUci
       })

   
    },
    postUci (data){
      this.$store.dispatch('albumInfo/uciGenerate', this.$route.params.id).then((result) => {
        
        this.uciResult.listData = result.data
        this.loadingHide();
        this.openModal('uci')
      }).catch((err) => {
        this.loadingHide();
        this.alert({msg:err.message})
      })
    },
    async exportCirculationFile () {
      swal.fire({
        title: '파일 다운로드 요청중입니다.',
        allowOutsideClick: false,
        onBeforeOpen: () => {
          swal.showLoading()
        },
      })

      await new Promise((resolve, reject) => setTimeout(resolve, 500))

      $api({
        method: 'get',
        url: `/album/${this.$route.params.id}/download`,
        responseType: 'arraybuffer',
      }).then((res) => {
        swal.close()
        swal.fire({
          type: 'success',
          html: `파일 다운로드 요청이 완료 되었습니다.
                <br>작업이 완료되면 다운로드 링크가
                <br>알림(slack)으로 전송 될 것입니다.`,
        })
      }).catch((err) => {
        swal.close()
        swal.fire({
          type: 'error',
          title: '파일 다운로드 요청이 실패 했습니다.',
        })
        
      })
    },
    async exportCirculationFile2 () {
      swal.fire({
        title: '파일 다운로드 요청중입니다.',
        allowOutsideClick: false,
        onBeforeOpen: () => {
          swal.showLoading()
        },
      })

      await new Promise((resolve, reject) => setTimeout(resolve, 500))

      $api({
        method: 'get',
        url: `/album/${this.$route.params.id}/download-tracklist`,
        responseType: 'arraybuffer',
      }).then((res) => {
        swal.close()
        swal.fire({
          type: 'success',
          html: `파일 다운로드 요청이 완료 되었습니다.
                <br>작업이 완료되면 다운로드 링크가
                <br>알림(slack)으로 전송 될 것입니다.`,
        })
      }).catch((err) => {
        swal.close()
        swal.fire({
          type: 'error',
          title: '파일 다운로드 요청이 실패 했습니다.',
        })
        
      })
    },
    async ddexFile(){
      swal.fire({
        title: '파일 다운로드 요청중입니다.',
        allowOutsideClick: false,
        onBeforeOpen: () => {
          swal.showLoading()
        },
      })
      await new Promise((resolve, reject) => setTimeout(resolve, 500))
      $api({
        method: 'get',
        url: `/album/${this.$route.params.id}/download-ddex`,
        responseType: 'arraybuffer',
      }).then((res) => {
        swal.close()
        swal.fire({
          type: 'success',
          html: `파일 다운로드 요청이 완료 되었습니다.
                <br>작업이 완료되면 다운로드 링크가
                <br>알림(slack)으로 전송 될 것입니다.`,
        })
      }).catch((err) => {
        swal.close()
        swal.fire({
          type: 'error',
          title: '파일 다운로드 요청이 실패 했습니다.',
        })
        
      })
    },
    mimsExport(){
      /* attachment;filename*=UTF-8''MIMS_EXPORT_SRAA132079_20200728.xlsx */
      this.$store.dispatch("albumInfo/mimsExport", `${this.$route.params.id}`)
      .then(result => console.log("Download success")).catch(error=>{
        console.log("down error::", error.response)
      })
    },
    setUserFee(){
      if(this.selectLicensor.length == 0){
        this.alert({msg : '라이센서 매칭을 진행해주세요.'})
        return false
      }
      this.service_fee_kr = this.selectLicensor[0].licensor.default_service_fee_kr
      this.service_fee_other = this.selectLicensor[0].licensor.default_service_fee_other
    },
    deleteAlbum(){
      let text = "앨범을 임시삭제 하시곘습니까?"
      if(this.albumStatus == 'trash'){
        text =' 앨범을 완전삭제하시겠습니까?'
      }
      this.confirm({
        title : '앨범 삭제 확인',
        width :400,
        msg : text,
        action : ()=>{
              const payload = {
                  id : `${this.$route.params.id}`
              }
              this.loadingShow()
              this.$store.dispatch("DELETE_ALBUM", payload)
              .then(result =>{
                  this.loadingHide();
                  this.$router.push('/album')
              }).catch(error =>{
                  this.loadingHide();
                  switch(error.response.data.code) {
                  default:
                    this.alert({msg:error.response.data.message})
                  break;
                }
              })
          }
      })
      
    },

    matchtableList(){
      this.matchtableAlbumCode(1)
      this.matchtableAlbumName(1)
      this.matchtableTrackCode(1)
      this.matchtableTrackName(1)
    },
    matchtableAlbumCode(pageIndex){
      const payload = {
        id : `${this.$route.params.id}`,
        params:{
          page: pageIndex? pageIndex-1 : this.errorAlbumCode.currentPage-1 ,
          limit: 5,
        }
      }
      this.$store.dispatch('LIST_MATCHTABLE_ALBUM_CODE', payload)
        .then(result =>{
        this.errorAlbumCode.listData  = result.items // 권리자 목록
        //페이지 수
        const remainder = parseInt(result.filtered % 10) > 0? 1: 0
        this.errorAlbumCode.totalPage = parseInt(result.filtered / 10) + remainder
      })
    },
    matchtableAlbumName(pageIndex){
      const payload = {
        id : `${this.$route.params.id}`,
        params:{
          page: pageIndex? pageIndex-1 : this.errorAlbumName.currentPage-1 ,
          limit: 5,
        }
      }
      this.$store.dispatch('LIST_MATCHTABLE_ALBUM_NAME', payload)
      .then(result =>{
        this.errorAlbumName.listData  = result.items // 권리자 목록
        //페이지 수
        const remainder = parseInt(result.filtered % 10) > 0? 1: 0
        this.errorAlbumName.totalPage = parseInt(result.filtered / 10) + remainder
      })
    },
    matchtableTrackCode(pageIndex){
      const payload = {
        id : `${this.$route.params.id}`,
        params:{
          page: pageIndex? pageIndex-1 : this.errorTrackCode.currentPage-1 ,
          limit: 5,
        }
      }
      
      this.$store.dispatch('LIST_MATCHTABLE_TRACK_CODE', payload)
      .then(result =>{
        this.errorTrackCode.listData  = result.items // 권리자 목록
        //페이지 수
        const remainder = parseInt(result.filtered % 10) > 0? 1: 0
        this.errorTrackCode.totalPage = parseInt(result.filtered / 10) + remainder
      })
    },
    matchtableTrackName(pageIndex){
      const payload = {
        id : `${this.$route.params.id}`,
        params:{
          page: pageIndex? pageIndex-1 : this.errorTrackName.currentPage-1 ,
          limit: 5,
        }
      }
      this.$store.dispatch('LIST_MATCHTABLE_TRACK_NAME', payload)
      .then(result =>{
        this.errorTrackName.listData  = result.items // 권리자 목록
        //페이지 수
        const remainder = parseInt(result.filtered % 10) > 0? 1: 0
        this.errorTrackName.totalPage = parseInt(result.filtered / 10) + remainder
      })
    },
    generateContract(){
      const payload = {
        id : `${this.$route.params.id}`,
      }
      if(this.albumStatus != 'registration_complete' && this.albumStatus != 'registration_canceled' && this.release_date){
        this.loadingShow()
        this.$store.dispatch('GENERATE_CONTRACKT', payload)
        .then(result =>{
          this.datacall()
        })
      }else{
        this.alert({msg: '접수 또는 유통취소상태 이거나 발매일이 없을 경우 생성이 불가능합니다.'})
      }
      
    },
    
    
    monitoringList(){
      const payload = {
        id : `${this.$route.params.id}`,
        params : {
          sort: 'created_at',
          sortorder: 'desc',
          page: this.monitoring.currentPage - 1,
          limit: 5
        }
      }
      this.loadingShow()
      this.$store.dispatch('ALBUM_RELEASE_MONITORING_LIST', payload)
        .then(result =>{
          
          this.monitoring.listData  = result.items // 권리자 목록
          //페이지 수
          const remainder = parseInt(result.filtered % 5) > 0? 1: 0
          this.monitoring.totalPage = parseInt(result.filtered / 5) + remainder
          this.monitoring.total = result.filtered
          this.loadingHide()

      }).catch(error =>{
        this.loadingHide();
        switch(error.response.data.code) {
          default:
            this.alert({msg:error.response.data.message})
            break;
        }
      })
    },
    monitoringDelete(id){
      this.confirm({
        title : '삭제 확인',
        msg : `
          선택하신 데이터를 정말 삭제 하시겠습니까?
        `,
        action : ()=>{
          const payload = {
            id : `${this.$route.params.id}`,
            release_monitoring_id : id
          }
          this.loadingShow()
          this.$store.dispatch('ALBUM_RELEASE_MONITORING_DELETE', payload)
            .then(result =>{
            this.noti('삭제되었습니다')
            this.monitoringList()
          }).catch(error =>{
            this.loadingHide();
            switch(error.response.data.code) {
              default:
                this.alert({msg:error.response.data.message})
                break;
            }
          })
        }
      })
    },
    monitoringAdd(){
      this.monitoringData = {
        page : null,
        page_type : null,
        url : null,
        store : null,
      }
      this.files4 =[]
      this.file4 = {
        id :null,
        preview : ''
      }
      this.openModal('monitoring')
      
    },
    monitoringPost(){
      console.log(this.file4)
      if(!this.file4.id){
        this.alert({msg:'이미지를 등록해주세요.'})
        return false
      }
      if(this.valCheck(this.monitoringData.page_type)){
        this.alert({msg:'type을 선택 해주세요.'})
        return false
      }
      const payload = {
        id : `${this.$route.params.id}`,
        params : {
          ...this.monitoringData,
          file_id : this.file4.id
        }
      }
      this.loadingShow()
      this.$store.dispatch('ALBUM_RELEASE_MONITORING_POST', payload)
        .then(result =>{

        this.closeModal('monitoring')
        this.monitoringData = {
          page : null,
          page_type : null,
          url : null,
          store : null,
        }
        this.noti('등록되었습니다')
        this.monitoringList()
      }).catch(error =>{
        this.loadingHide();
        switch(error.response.data.code) {
          default:
            this.alert({msg:error.response.data.message})
            break;
        }
      })
      
    },
    //monitoring image
    inputFileUpload4(newFile, oldFile) {
      
      if (newFile && !oldFile) {
        // add
        if(newFile.type.indexOf('image') < 0 ){
          this.alert({msg:'이미지만 등록 가능합니다.'})
          return false
        }
        this.$refs.upload4.active = true
        let file = newFile.file
        let reader = new FileReader
        reader.onload = e => {
          this.file4.preview = e.target.result
        }
        reader.readAsDataURL(file)
      }
      if (newFile && oldFile) {
        // update
        if(Array.isArray(newFile.response)){
          this.file4 ={
            ...this.file4,
            ...newFile.response[0]
          }
        }
        
      }
      if (!newFile && oldFile) {
        // remove
        
      }
    },
    
    getVideoList() {
      const payload = {
        role: 'album',
        id : `${this.$route.params.id}`,
        params : {
          sort: 'created_at',
          sortorder: 'desc',
          page: this.video.currentPage - 1,
          limit: 10
        }
      }
      this.loadingShow()
      this.$store.dispatch('GET_ALBUM_VIDEO', payload)
      .then(result =>{
        this.loadingHide()
        this.videoCount = result.data.total
        this.video.listData = result.data.items
        const remainder = parseInt(result.data.total % 10) > 0 ? 1: 0
        this.video.totalPage = parseInt(result.data.total/10) + remainder

      })
    },
    videoFileFilter(newFile, oldFile) {
      if (newFile && !oldFile) {
        
        if(newFile.type !== "" && newFile.type.indexOf('video') < 0  ){
          
          this.alert({msg:'video파일만 등록 가능합니다.'})
            setTimeout(() => {
              this.videoFile = []
          }, 0);
          return false
        }else if(newFile.type == ""){
          if(newFile.name.indexOf('avi')< 0 && newFile.name.indexOf('mp4') < 0 && newFile.name.indexOf('mov') < 0){
            console.log(newFile)
            this.alert({msg:'avi,mov,mp4형식 video파일만 등록 가능합니다.'})
              setTimeout(() => {
                this.videoFile = []
            }, 0);
            return false
          }
        }
        //this.$refs.videoFile.active = true
        let file = newFile.file
        let reader = new FileReader

        const metadata = getMetadata(newFile.file).then(result =>{
          this.videoFile[0] = {
            ...this.videoFile[0],
            ...result
          }
        });

        // reader.onload = e => {
        //   this.videoFile.preview = e.target.result
          
        //   console.log('e',e)
        //   console.log(metadata)

        // }
        // reader.readAsDataURL(file)
      }
      if (newFile && oldFile) {
        // update
        if(Array.isArray(newFile.response)){
          this.videoFile ={
            ...this.videoFile,
            ...newFile.response[0]
          }
        }
      }
    },
    //비디오 썸네일
    videoThumnailFileFilter(newFile, oldFile) {
     this.$refs.videoThumnailFile.active = false
      if (newFile && !oldFile) {
        // add
        
        if(newFile.type.indexOf('image') < 0 ){
          this.alert({msg:'이미지만 등록 가능합니다.'})
          return false
        }
        
        let file = newFile.file
        let reader = new FileReader
        reader.onload = e => {
          this.videoThumnailFile[0].preview = e.target.result
          //this.loadingShow()
          this.loadingHide()
          this.$refs.videoThumnailFile.active = true
        }
        reader.readAsDataURL(file)
        
      }
      
      if (newFile && oldFile) {
        
        if(newFile != oldFile){
          
          this.$refs.videoThumnailFile.active = true
        }
        // update
        if(Array.isArray(newFile.response)){
          this.videoThumnailFile[0] = {
            ...this.videoThumnailFile[0],
            ...newFile.response[0]
          }
          this.loadingHide()
        }
      }
      if (!newFile && oldFile) {
        // remove
      }
    },
    //비디오 심의 파일
    videoReviewFileFilter(newFile, oldFile) {
      if (newFile && !oldFile) {
         if(newFile.size > 11429478.4 ){
          this.alert({msg:'10MB 까지만 등록 가능합니다.'})
          return false
        }
        let file = newFile.file
        let reader = new FileReader
        reader.onload = e => {
          this.videoReviewFile[0].preview = e.target.result
          this.$refs.videoReviewFile.active = true
          this.loadingShow()
        }
        reader.readAsDataURL(file)
        
      }
      
      if (newFile && oldFile) {
        if(newFile != oldFile){
          
          this.$refs.videoReviewFile.active = true
        }
        // update
        if(Array.isArray(newFile.response)){
          this.videoReviewFile[0] = {
            ...this.videoReviewFile[0],
            ...newFile.response[0]
            
          }
          this.$refs.videoReviewFile.active = false
          this.loadingHide()
        }
      }
    },
    openVideo(){
      this.trackOption = [
        {id : null, name :'없음'},
        ...this.trackAll
      ]
      this.videoEditMode = false
      this.videoData = {
        video_id : null,
        track_id :  null,
        type : 'mv', //  (mv, teaser, makingof, other)
        is_reviewed : false,
        review_office : null,
        review_date :null ,
        review_classification : null,
        thumbnail_id : null,
        language : null,
        title : null,
        description : null,
        file_id : null,
        barcode : null,
        isrc : null,
        start_date: null,
        start_time: null,
        start_timezone: null,
        end_date: null,
        end_time: null,
        end_timezone: null,
      }
      this.videoFile = []
      this.videoThumnailFile = []
      this.videoReviewFile = []
      
      this.openModal('video')
    },
    postVideo(){
      let payload = {
        id : `${this.$route.params.id}`,
        params : {
          ...this.videoData
        }
      }
      let url 
      if(this.videoEditMode){
        url = 'PUT_ALBUM_VIDEO'
        payload['video_id'] = this.videoData.id
      }else { 
        url = 'POST_ALBUM_VIDEO'
      }
    
      if(!this.videoEditMode && this.valCheck(this.videoFile[0])){
        this.alert({msg: '비디오 파일을 선택해주세요.'})
        return false;
      }

      if(this.videoThumnailFile[0]) {
        payload.params['thumbnail_id'] = Number(this.videoThumnailFile[0].id)
      }else{
        payload.params['thumbnail_id'] = null
      }
      if(this.videoReviewFile[0]) {
        payload.params['file_id'] = Number(this.videoReviewFile[0].id)
      }else{
        payload.params['file_id'] = null
      }
      
      //return false
        //선급금 계약

      this.loadingShow()
      if(this.videoFile[0] && this.videoFile[0].id != this.videoData.video_id  ){
        this.$store.dispatch("albumInfo/uploadImageFile", this.videoFile[0].file)
        .then(result =>{
          
          // 비디오 업로드 후 데이터 저장
          this.videoData.video_id = result[0].id
          payload.params['video_id'] = result[0].id
          this.$store.dispatch(url, payload)
          .then(result =>{
            this.loadingHide();
            this.closeModal('video')
            this.noti('비디오가 정상적으로 저장 되었습니다.')
            this.getVideoList()
          }).catch(error =>{
            this.loadingHide();
            switch(error.response.data.code) {
              default:
                this.alert({msg:error.response.data.message})
                break;
            }
          })
        }).catch(error => {
          this.loadingHide();
          this.alert({msg:'파일 업로드가 실패했습니다. 다시 시도해주세요.'})
        })
      }else{
        delete payload.params.video_id
        if(this.valCheck(payload.params.file_id)){
          payload.params.file_id = null
        }
        if(this.valCheck(payload.params.thumbnail_id)){
           payload.params.thumbnail_id = null
        }
        this.$store.dispatch(url, payload)
          .then(result =>{
            this.loadingHide();
            this.closeModal('video')
            this.noti('비디오가 정상적으로 저장 되었습니다.')
            this.getVideoList()    
          }).catch(error =>{
            this.loadingHide();
            switch(error.response.data.code) {
              default:
                this.alert({msg:error.response.data.message})
                break;
            }
        })
      }
    },
    openEditVideo(data){
      this.trackOption = [
        {id : null, name :'없음'},
        ...this.trackAll
      ]
      this.videoData ={
        ...data,
      }
      console.log(this.videoData)
      this.videoFile = []
      this.videoThumnailFile = []
      this.videoReviewFile = []
      this.videoEditMode = true
      if(data.video) this.videoFile =[{...data.video , preview:data.video.remote_path}]
      if(data.thumbnail) this.videoThumnailFile = [{...data.thumbnail , preview:data.thumbnail.remote_path}]
      if(data.file) this.videoReviewFile =[{...data.file,preview:data.file.remote_path}]
      this.openModal('video')
    },
    officeChange(){
      this.videoData.review_office = '' + this.officeOptionSelect
      this.officeOptionSelect = null
    },
    editVideo(){

    },
    deleteVideo(video){
      let data = video
      this.confirm({
        title : '비디오 삭제',
        msg : `
          선택하신 비디오를 삭제하시겠습니까?
        `,
        action :()=>{
          let payload ={
            id : `${this.$route.params.id}`,
            video_id : data.id
          }
          this.loadingShow();
          this.$store.dispatch("DELETE_ALBUM_VIDEO",payload )
          .then(result =>{
            this.noti('삭제되었습니다.')
            this.getVideoList()
          }).catch(error =>{
            this.loadingHide();
            switch(error.response.data.code) {
              default:
                this.alert({msg:error.response.data.message})
                break;
            }
          })
        }
      })
    },
    callHistory(){
      this.getIngestion();
      this.getDjList();
    },
    getIngestion() {
      const payload = {
        id : `${this.$route.params.id}`,
        params : {
          sort: 'created_at',
          sortorder: 'desc',
          page: this.ingestionData.currentPage - 1,
          limit: 10
        }
      }
      if(this.ingestionDate){
        payload.params['created_at'] = this.ingestionDate
      }
      
      this.loadingShow()
      this.$store.dispatch('GET_INGESTION_HISTORY', payload)
      .then(result =>{
        this.loadingHide()
        
        this.ingestionCount = result.data.total
        this.ingestionData.listData = result.data.items
        const remainder = parseInt(result.data.total % 10) > 0 ? 1: 0
        this.ingestionData.totalPage = parseInt(result.data.total/10) + remainder

      })
    },
    getDjList(){
      const payload = {
        id : `${this.$route.params.id}`,
        params : {
          page: this.djData.currentPage - 1,
          limit: 10
        }
      }

      
      this.loadingShow()
      this.$store.dispatch('GET_DJ_HISTORY', payload)
      .then(result =>{
        this.loadingHide()
        
        this.djData.total = result.data.total
        this.djData.listData = result.data.items
        const remainder = parseInt(result.data.total % 10) > 0 ? 1: 0
        this.djData.totalPage = parseInt(result.data.total/10) + remainder

      })
    },

    djViewDetail(id){
      let url = '/ddex/job/detail/' +id
      window.open(url);
    },

    openContractLincesor(){
      const array = [] 
      const finalData = JSON.parse(JSON.stringify(this.contract.contract_licensor));
      
      
      for(let i in finalData ){
        if(this.contract.is_even_distribution){
          finalData[i].ratio = 100/finalData.length
        }
      }
      this.contractLicensorList = finalData
      
      this.is_even_distribution = this.contract.is_even_distribution
      this.openModal('contractLicensor')
    },
    saveContractLicensor(){
      let payload = {
        id:  `${this.$route.params.id}`,
        params : {
          id : this.contract.id,
          is_even_distribution: this.is_even_distribution,
          contract_licensor: []
        }
      }
      let array = []
      for(let i in this.contractLicensorList){
        if(this.contractLicensorList[i].id){
          array.push({
              id: this.contractLicensorList[i].id,
              contract_id: this.contractLicensorList[i].contract_id,
              licensor_id: this.contractLicensorList[i].licensor_id,
              ratio: Number(this.contractLicensorList[i].ratio),
          })
        }else{
          array.push({
              licensor_id: this.contractLicensorList[i].licensor_id,
              ratio: Number(this.contractLicensorList[i].ratio),
          })
        }
      }
      payload.params.contract_licensor = array

      
      //
      
      if(!this.is_even_distribution && this.sumRatio != 100){
        this.alert({msg:"전체 비율 합을 100%로 맞춰주세요"})
        return false
      }
      this.loadingShow()
      this.$store.dispatch('PUT_ALBUM_LICENSOR', payload)
          .then(result =>{
            this.loadingHide();
            
            this.closeModal('contractLicensor')
            this.contract.contract_licensor = result.contract_licensor
            this.contract.is_even_distribution = result.is_even_distribution
            
          }).catch(error =>{
            switch(error.response.data.code) {
              default:
                this.alert({msg:error.response.data.message})
                break;
            }
        })
    },
    
    deleteLicensor(index){
      this.contractLicensorList.splice(index,1)
    },
    openEditContract(){
      
      let data = JSON.parse(JSON.stringify(this.contract));
      this.service_fee_kr = data.service_fee_kr
      this.service_fee_other = data.service_fee_other
      this.openModal('contract')
    },
    saveContract(){
      let payload = {
        id:  `${this.$route.params.id}`,
        params : {
          service_fee_kr : this.service_fee_kr,
          service_fee_other : this.service_fee_other
        }
      }
      this.loadingShow()
      this.$store.dispatch("PUT_ALBUM_CONTRACT", payload)
      .then(result =>{
        this.closeModal('contract')
        this.loadingHide();
        this.datacall()
      }).catch(error =>{
        this.loadingHide();
        switch(error.response.data.code) {
          default:
            this.alert({msg:error})
            break;
        }
      })
    },
    fileTransfer(){
      
      if(!this.mp3File && !this.wavFile && !this.flacFile ){
        this.alert({msg:'1개 이상은 Yes를 선택해주세요.'})
      }
      const payload = {
        id : `${this.$route.params.id}`,
        params : {
          'wav': this.wavFile, 
          'mp3': this.mp3File,
          'flac': this.flacFile
        }
      }
      this.loadingShow()
      this.$store.dispatch('POST_TRANS_FILE', payload)
      .then(result =>{
        this.datacall()
        this.wavFile = true
        this.mp3File = true
        this.flacFile = true
        this.closeModal('transcoding')
        this.noti('변환 요청 되었습니다.')
        
      }).catch(error =>{
        this.loadingHide();
        switch(error.response.data.code) {
          default:
          this.alert({msg:error.response.data.message})
          break;
        }
      })
    },
    checkTransCoding(){
      let payload = {
        id : `${this.$route.params.id}`
      }
      this.$store.dispatch('GET_ALBUM', payload)
        .then(result =>{
            let t = result.data;
            this.transcoding_in_progress = t.transcoding_in_progress
            
            const track = []
            const numbering = [];
            this.trackAll = t.tracks
            for(var i in t.tracks){
              if(numbering.indexOf(t.tracks[i].volume-1) > -1){
                track[numbering.indexOf(t.tracks[i].volume-1)].push(t.tracks[i])
              }else{
                numbering.push(t.tracks[i].volume-1)
                track.push([t.tracks[i]])
                
              }
            }
            this.trackList = track
            if(this.trackList.length ==  0 ) {
              this.trackList = [[]]
            }
            
            this.transcoding_in_progress = t.transcoding_in_progress
            this.loadingHide();
            if(this.transcoding_in_progress){
              this.noti('아직 처리중입니다.')
            }else{
              this.noti('변환 완료되었습니다.')
            }
            
        }).catch(error=>{
          const status = error.status
          switch(status){
              case 401:
              this.$store.dispatch('TOKEN_ITEM_CLEAR').then(()=>{this.$router.push('/login')})
              break;
              default:
                this.alert({msg:error})
              break;
          }
      })
      
    },
    getSpetrogram(data,findex){
      console.log(data)
      let t = data.files[findex] 
      console.log(t)
      let payload = {
        id : `${this.$route.params.id}`,
        track_id : data.id,
        file_id : t.id
      }
      this.$store.dispatch('GET_SPECTROGRAM', payload)
        .then(result =>{
            let t = result.data;
            console.log(result)
            this.loadingHide();
            this.noti('이미지 생성 요청되었습니다.')
            
        }).catch(error=>{
          const status = error.status
          switch(status){
              case 401:
              this.$store.dispatch('TOKEN_ITEM_CLEAR').then(()=>{this.$router.push('/login')})
              break;
              default:
                this.alert({msg:error})
              break;
          }
      })
      
    },
    updateLang(data){
      this.name_multilang = data
      this.$forceUpdate()
    },
    updateDjLang(data){
      this.name_export = data
      this.$forceUpdate()
    },

    updateTrackLang(data){
      this.trackDetail.name_multilang =data
      this.$forceUpdate()
    },
    updateTrackDjLang(data){
      this.trackDetail.name_export = data
      this.$forceUpdate()
    },
    

    //dolby
    inputFileUpload5(newFile, oldFile) {
      
      if (newFile && !oldFile) {
        // add
        if(newFile.type.indexOf('wav') < 0 ){
          
          
          
          this.$refs.upload5.active = false
          setTimeout(() => {
            this.files5 = []
            this.$refs.upload5.remove(newFile)  
          }, 0);
          this.$forceUpdate()
          this.alert({msg:'오디오(wav) 파일만 가능합니다.'});
          return prevent()
        }
        
       
        let file = newFile.file
        let reader = new FileReader
        this.loadingShow();
        reader.onload = e => {
          
          const dd = this.getMetadata(file)
          dd.then(result =>{
            if(result.format.numberOfChannels > 2){
              this.$refs.upload5.active = true
              this.file5.preview = e.target.result
            }else{
              this.alert({msg:'Dolby 음원이 아닙니다.'})
              this.$refs.upload5.remove(newFile)
              this.files5 = []
              this.loadingHide();
              return false
            }
          })
        }
        reader.readAsDataURL(file)
      }
      if (newFile && oldFile) {
        // update
        if(Array.isArray(newFile.response)){
          this.file5 ={
            ...this.file5,
            ...newFile.response[0]
          }
        }
        if(newFile.progress == '100.00' ){
          this.loadingHide()
        }
        if(newFile.progress == '0.00' ){
        }
      }
     
      if (!newFile && oldFile) {
        // remove
        
      }
    },
    async getMetadata(file){
      console.log(`Parsing file "${file.name}" of type ${file.type}`);

      return mmb.parseBlob(file, {native: true}).then(metadata => {
        console.log(`Completed parsing of ${file.name}:`, metadata);
        return metadata;
      })
    },
    removeDolbyFile(){
      this.loadingShow();
      console.log(this.trackDetail)
      if(this.trackDetail.dolbyatmos_id){
        const payload = {
          album_id : this.$route.params.id,
          track_id : this.trackDetail.id,
        }
        this.$store.dispatch("DELETE_DOLBY_FILE", payload)
        .then(result => {
          this.loadingHide();
          this.noti('삭제되었습니다.')
          this.datacall()
          this.files5 = []
          this.file5 = {
            id :null,
            preview : ''
          }
          this.trackDetail.dolbyatmos_id = null
        }).catch(error=>{
          this.loadingHide();
          switch(error.response.data.code) {
            default:
              this.alert({msg:error})
              break;
          }
        })
      }else{
        const payload = {
          id : this.files5[0].response[0].id
        }
        this.$store.dispatch("DELETE_ONLY_FILE", payload)
        .then(result => {
          this.loadingHide();
          this.noti('삭제되었습니다.')
          this.files5 = []
          this.file5 = {
            id :null,
            preview : ''
          }
          this.trackDetail.dolbyatmos_id = null
        }).catch(error=>{
          this.loadingHide();
          switch(error.response.data.code) {
            default:
              this.alert({msg:error})
              break;
          }
        })
        this.files5 = []
        this.file5 = {
          id :null,
          preview : ''
        }
      }
      
    },

    removeAppleDigitalMasterFile(){
      this.loadingShow();
      const payload = {
        album_id : this.$route.params.id,
        track_id : this.trackDetail.id,
        file_id : this.trackDetail.appledigitalmaster_id
      }
      this.$store.dispatch("DELETE_APPLE_DIGITAL_MASTER_FILE", payload)
      .then(() => {
        this.loadingHide();
        this.noti('삭제되었습니다.')
        this.files6 = []
        this.file6 = { id: null, preview: '' }
        this.trackDetail.appledigitalmaster_id = null
        this.datacall()
      }).catch(error=>{
        this.loadingHide();
        switch(error.response.data.code) {
          default:
            this.alert({msg: error})
            break;
        }
      })
    },

    inputFileUpload6(newFile, oldFile) {
      if (newFile && !oldFile) {
        // add
       
        
        let file = newFile.file
        let reader = new FileReader
        this.loadingShow();
        reader.onload = e => {
          const dd = this.getMetadata(file)
          dd.then(result =>{
            this.$refs.upload6.active = true
            this.file6.preview = e.target.result
          })
        }
        reader.readAsDataURL(file)
      }
      if (newFile && oldFile) {
        // update
        if(Array.isArray(newFile.response)){
          this.file6 ={
            ...this.file6,
            ...newFile.response[0]
          }
        }
        if(newFile.progress == '100.00' ){
          this.loadingHide()
        }
        if(newFile.progress == '0.00' ){
        }
      }
     
      if (!newFile && oldFile) {
        // remove
        
      }
    },



    closeTrack(event){
      
      if(this.$refs.upload5.active){
        this.files5 = []
        this.file5 = {
          id :null,
          preview : ''
        }
        
        this.$refs.upload5.active=false
        
        this.$forceUpdate()
        this.alert({msg:'업로드가 중지되었습니다.'})
        event.cancel()
      }
      if(this.$refs.upload3.active){
        
        this.$refs.upload3.active=false
        this.alert({msg:'업로드가 중지되었습니다.'})
        event.cancel()
      }
      //this.$refs.upload3.update(this.files3, {error: 'cancel'}) 
      
    },
    openMotionart(){
      this.openModal('motionart')
      this.motionartData = {
        motionart11: this.motionart11,
        motionart11_id : this.motionart11_id,
        motionart34 : this.motionart34,
        motionart34_id : this.motionart34_id,
      }
    },
    fileChange(e){
      if(e.target.files.length < 1){
        return false
      }
      let name = e.target.name
      this.loadingShow()
      const payload = {
        file: e.target.files[0],
      }
      
      this.$store.dispatch('POST_ONLY_FILE', payload)
      .then(result =>{
       
          let image_width =result[0].metadata.image_width 
              ,image_height = result[0].metadata.image_height 
              ,duration = result[0].metadata.duration; 
          if(name =='MOTION1'){
            if( (image_width == 3840 && image_height == 3840 ) && 9 < duration < 36){
              this.motionartData.motionart11_id  = result[0].id
              this.motionartData.motionart11  = result[0]
              this.loadingHide();
            }else{
              const fileID = {
                id : result[0].id
              }
              this.$store.dispatch("DELETE_ONLY_FILE", fileID)
              .then(result => {
                this.loadingHide();
                e.target.value = ''
                this.alert({msg : '파일 규격을 확인해주세요. <br> Image Size :  : 3X4(3840X3840), <br> Filetype : MOV, <br> Duration : 10-35 sec'})
             
              }).catch(error=>{
                this.loadingHide();
                this.alert({msg:error})
              })
            }
           
          }else{
            if( (image_width == 2048 && image_height == 2732 ) && 9 < duration < 36){
              this.motionartData.motionart34_id  = result[0].id
              this.motionartData.motionart34  = result[0]
              this.loadingHide();
            }else{
              const fileID = {
                id : result[0].id
              }
              this.$store.dispatch("DELETE_ONLY_FILE", fileID)
              .then(result => {
                this.loadingHide();
                e.target.value = ''
                this.alert({msg : '파일 규격을 확인해주세요. <br> Image Size :  : 3X4(2048X2732), <br> Filetype : MOV,<br>  Duration : 10-35 sec'})
             
              }).catch(error=>{
                this.loadingHide();
                 
              })
            }
            
          }
          
      }).catch(error=>{
        this.loadingHide()
        this.alert({msg:error})
      })
    },
    motionartPost(){
      let payload = {
        id : `${this.$route.params.id}`,
        params:{
          motionart11_id : this.motionartData.motionart11_id,
          motionart34_id : this.motionartData.motionart34_id,
        }
      }
      if(!this.motionartData.motionart11_id) {
        this.alert({msg:'모션아트파일 2개를 모두 올려주세요.'})
        return false
      }
      if(!this.motionartData.motionart34_id){
        this.alert({msg:'모션아트파일 2개를 모두 올려주세요.'})
        return false
      }
      this.loadingShow()
      this.$store.dispatch("PUT_ALBUM_V2", payload)
      .then(result =>{
        this.loadingHide();
        this.datacall()
        this.noti('저장 하였습니다.')
        this.closeModal('motionart')
      }).catch(error =>{
        this.loadingHide();
        switch(error.response.data.code) {
          default:
            this.alert({msg:error})
            break;
        }
      })
    },
    
    deleteMotionart(){
      this.confirm({
        title: '모션아트 파일 삭제',
        msg : '모션아트파일 전부가 삭제됩니다. <br> 삭제하시겠습니까?',
        action:()=>{
          this.loadingShow();
          let payload = {
            id : `${this.$route.params.id}`,
            params:{
              motionart11_id : null,
              motionart34_id : null,
            }
          }
          this.$store.dispatch("PUT_ALBUM_V2", payload)
          .then(result =>{
            this.datacall()
            this.noti('삭제 하였습니다.')
          }).catch(error =>{
            this.loadingHide();
            switch(error.response.data.code) {
              default:
                this.alert({msg:error})
                break;
            }
          })
        }
      })
      
    },
    testColor(url){
        let downloadedImg = new Image();
            downloadedImg.crossOrigin = "anonymous";
            downloadedImg.src = url;
        var blockSize = 5, // only visit every 5 pixels
            defaultRGB = {r:0,g:0,b:0}, // for non-supporting envs
            canvas = document.createElement('canvas'),
            context = canvas.getContext && canvas.getContext('2d'),
            data, width, height,
            i = -4,
            length,
            rgb = {r:0,g:0,b:0},
            count = 0;
            
        if (!context) {
            return defaultRGB;
        }

        height = canvas.height = imgEl.naturalHeight || imgEl.offsetHeight || imgEl.height;
        width = canvas.width = imgEl.naturalWidth || imgEl.offsetWidth || imgEl.width;

        context.drawImage(imgEl, 0, 0);

        try {
            data = context.getImageData(0, 0, width, height);
            
        } catch(e) {
            console.log(e)
            /* security error, img on diff domain */alert('x');
            return defaultRGB;
        }

        length = data.data.length;

        while ( (i += blockSize * 4) < length ) {
            ++count;
            rgb.r += data.data[i];
            rgb.g += data.data[i+1];
            rgb.b += data.data[i+2];
        }

        // ~~ used to floor values
        rgb.r = ~~(rgb.r/count);
        rgb.g = ~~(rgb.g/count);
        rgb.b = ~~(rgb.b/count);
        console.log(rgb)
        return rgb;
    },



    
    linkGenerate(){
      const payload = {
        id : `${this.$route.params.id}`,
      }
      this.loadingShow()
      this.$store.dispatch('ALBUM_LINK_GENERATE', payload)
        .then(result =>{
        
        this.loadingHide()
        this.datacall()
        this.noti('스마트링크가 생성되었습니다.')
      }).catch(error =>{
        this.loadingHide();
        switch(error.response.data.code) {
          default:
            this.alert({msg:error.response.data.message})
            break;
        }
      })
    },
    //스마트링크 복사
    doCopy() {
      let text = ''
      let sample = '';
      for(var j in this.selectArtist){
        if(this.selectArtist[j].display_name){
          if(j != 0 ){
            text += ', '
            sample += ', '
          }
          text += this.selectArtist[j].display_name
          sample += this.selectArtist[j].display_name
        }
      }
      text += ' - ' +this.name
      sample += ' - ' +this.name
      for(var i in this.albumLinkList){
        if(this.albumLinkList[i].id){
          text += `\n - ${this.albumLinkList[i].name} : ${this.albumLinkList[i].link}`
          sample += `<br/> - ${this.albumLinkList[i].name} : ${this.albumLinkList[i].link}`
        }
      }
      this.$copyText(text).then((e) => {
          this.noti('링크목록을 복사했습니다. \ <br/>' + sample);
      }, function (e) {
          this.noti('실패했습니다.');
      }).catch(error =>{
        this.loadingHide();
        switch(error.response.data.code) {
          default:
            this.alert({msg:error})
            break;
        }
      })
      
    },
    postSmartLinkNoti(){
      let payload = {
        id:  `${this.$route.params.id}`,
        params : {
        }
      }
      this.loadingShow()
      this.$store.dispatch('POST_SMARTLINK_NOTIFICATION', payload)
      .then(result =>{
        this.loadingHide()
        this.alert({msg : `
          권리자에게 앨범 발매 스마트링크 알림톡과 메일 발송을 요청하였습니다.<br><br>
          *한국 휴대폰번호가 있는 경우에만 발송할 수 있습니다.(카카오톡이 없는 경우 문자로 발송됩니다.)<br>
          *발송 이력은 따로 저장되지 않습니다.
        `})
      }).catch(error=>{
          this.loadingHide()
          const status = error.response.status
          switch(status){
              case 401:
              this.$store.dispatch('TOKEN_ITEM_CLEAR').then(()=>{this.$router.push('/login')})
              break;
              default:
              this.alert({msg:error.response.data.message })
              break;
          }
      })
    },
    linkEditPost(){
      let payload = {
        id : `${this.$route.params.id}`,
        params : {
          smartlink_url  : this.smartlinkEditValue
        }
      }
      let text = this.smartlinkEditValue.replace('https://link.soundrepublica.com/','')
      if(this.smartlinkEditValue == 'https://link.soundrepublica.com/' ||  this.valCheck(text) || this.valCheck(this.smartlinkEditValue) || this.smartlinkEditValue.indexOf('https://link.soundrepublica.com/') < 0 ){
        this.alert({msg : '변경할 링크를 확인해주세요. \ https://link.soundrepublica.com/{link}'})
        return false
      }
      this.loadingShow()
      this.$store.dispatch("PUT_ALBUM_V2", payload)
      .then(result =>{
        this.loadingHide();
        this.closeModal('smartlinkEdit')
        this.noti('링크가 정상적으로 수정 되었습니다.')
        this.datacall()
      }).catch(error =>{
        this.loadingHide();
        switch(error.response.data.code) {
          default:
            this.alert({msg:error})
            break;
        }
      })
    },
    linkList(){
      const payload = {
        id : `${this.$route.params.id}`,
      }
      this.loadingShow()
      this.$store.dispatch('ALBUM_LINK_LIST', payload)
        .then(result =>{
          
          let t = result.items 
          let list = this.albumLinkList
          for(let i in list){
            var men = t.filter(function (item) { return item.type == list[i].type });
            
            if(men){
              this.albumLinkList[i] = {
                ...this.albumLinkListCopy[i],
                ...men[0]
              }
            }
            
          }
          this.$forceUpdate()
          this.loadingHide()
      }).catch(error =>{
        this.loadingHide();
        switch(error.response.data.code) {
          default:
            this.alert({msg:error.response.data.message})
            break;
        }
      })
    },
    linkPost(item){
      const payload = {
        id : `${this.$route.params.id}`,
        params : {
          type: item.type,
          link : item.link
        }
      }
      if(this.valCheck(item.link)){
        this.alert({msg : '링크를 입력해주세요.'})
        return false
      }
      this.loadingShow()
      this.$store.dispatch('ALBUM_LINK_POST', payload)
        .then(result =>{
        this.noti('저장되었습니다')
        this.linkList()
      }).catch(error =>{
        this.loadingHide();
        switch(error.response.data.code) {
          default:
            this.alert({msg:error})
            break;
        }
      })
    },
    linkEditMode(id){
      let list = this.albumLinkList 
      let index = list.findIndex( x => x.id === id );
      
      this.albumLinkList[index].edit = !this.albumLinkList[index].edit
      this.$forceUpdate()
    },
    linkEdit(item){
      const payload = {
        id : `${this.$route.params.id}`,
        link_id : item.id,
        params : {
          type: item.type,
          link : item.link
        }
      }
      this.$store.dispatch('ALBUM_LINK_PUT', payload)
        .then(result =>{
        this.noti('수정되었습니다')
      }).catch(error =>{
        this.loadingHide();
        switch(error.response.data.code) {
          default:
            this.alert({msg:error})
            break;
        }
      })
    },

    smartlinkEdit(item){
      const payload = {
        id : `${this.$route.params.id}`,
       
        params : {
          smartlink_type: this.smartlink_type,
          smartlink_color_box: this.smartlink_color_box,
          smartlink_color_text: this.smartlink_color_text,
          smartlink_description: this.smartlink_description,
          smartlink_video_main_url: this.smartlink_video_main_url,
          smartlink_video_sub_url: this.smartlink_video_sub_url
        }
      }
      // var men = t.filter(function (item) { return item.type == list[i].type });
      // Array.isArray(links.items) ? links.items.map(x => ({ type: x.type, link: x.link?.trim() })) : []
      // this.albumLinkList

      this.loadingShow()
      this.$store.dispatch('ALBUM_SMARTLINK_PUT', payload)
        .then(result =>{
        this.noti('수정되었습니다')
        this.datacall()
      }).catch(error =>{
        this.loadingHide();
        switch(error.response.data.code) {
          default:
            this.alert({msg:error})
            break;
        }
      })
    },
    linkDelete(item){
      const payload = {
        id : `${this.$route.params.id}`,
        link_id : item.id
      }
      this.$store.dispatch('ALBUM_LINK_DELETE', payload)
        .then(result =>{
        this.noti('삭제되었습니다')
        this.linkList()
      }).catch(error =>{
        this.loadingHide();
        switch(error.response.data.code) {
          default:
            this.alert({msg:error.response.data.message})
            break;
        }
      })
    },
    openLinkAddress(){
      this.linkAddress = null
      this.openModal('linkAddrss')

    },
    linkAddressEdit(){
      const payload = {
        id : `${this.$route.params.id}`,
        params: {new_ref : this.linkAddress}
      }
      if(this.valCheck(this.linkAddress)){
        this.alert({msg:'변경할 주소를 입력해주세요.'})
        return false
      }
      this.loadingShow()
      this.$store.dispatch('ALBUM_LINK_ADDRESS_EDIT', payload)
        .then(result =>{
        this.noti('저장되었습니다')
        this.closeModal('linkAddrss')
        this.datacall()
        
      }).catch(error =>{
        this.loadingHide();
        
        
        
      })
    },

    openCode(){
      this.barcodeGenerate = true
      this.isrcGenerate = true
      this.uciGenerate = true
      this.openModal('code')
    },
    codeGenerate(){
      const payload = {
        id : `${this.$route.params.id}`,
        params : {
            "generate_barcode": this.barcodeGenerate,
            "generate_isrc": this.isrcGenerate,
            "generate_uci": this.uciGenerate
        }
      }
      if(!this.uciGenerate && !this.barcodeGenerate&& !this.isrcGenerate){
        this.alert({msg:'1개 이상 선택 해주세요.'})
        return false
      }
      this.loadingShow()
      this.$store.dispatch('POST_ALBUM_CODE_GENERATE', payload)
        .then(result =>{
        
        this.loadingHide()
        this.code_generation_in_progress = true
        this.noti('코드 생성 결과는 Slack으로 발송됩니다.')
        
        this.closeModal('code')
      }).catch(error =>{
        this.loadingHide();
        switch(error.response.data.code) {
          default:
            this.alert({msg:error.response.data.message})
            break;
        }
      })
    },
    checkProcess(){
      let payload = {
        id : `${this.$route.params.id}`
      }
      this.loadingShow();
      this.$store.dispatch('GET_ALBUM_V2', payload)
        .then(result =>{
            let t = result.data;
            this.sr_representative = t.sr_representative
            this.transcoding_in_progress = t.transcoding_in_progress
            this.selectLicensor = [{
              ...t.licensor.user,
              licensor : t.licensor
            }]
            this.name_multilang  = t.name_multilang
            this.name_export = t.name_export
            this.release_type = t.release_type
            this.source = t.source
            this.albumStatus = t.state
            this.copyright = t.copyright_type
            this.distributor = t.distributor
            this.explicit  = t.explicit 
            
            this.name = t.name
            this.name_language = t.name_language 
            this.name_english = t.name_english 
            this.cline_text = t.cline_text 
            this.cline_year = t.cline_year ? String(t.cline_year) : null
            this.pline_text = t.pline_text
            this.pline_year = t.pline_year ? String(t.pline_year) : null
            this.description = t.description
            
            this.description_language = t.description_language
            this.description_english = t.description_english

            this.credit = t.credit 
            this.release_version = t.release_version
            this.smartlink_url = t.smartlink_url
            this.smartlink_id = t.smartlink_id

            this.smartlink_ref = t.smartlink_ref
            this.smartlink_type =  t.smartlink_type
            this.smartlink_video_main_url =  t.smartlink_video_main_url
            this.smartlink_video_sub_url =  t.smartlink_video_sub_url
            this.smartlink_color_box =  t.smartlink_color_box
            this.smartlink_color_text =  t.smartlink_color_text
            this.smartlink_description =  t.smartlink_description





            this.youtube_cid = t.youtube_cid
            this.youtube_sr = t.youtube_sr
            this.youtube_at = t.youtube_at
            this.album_ref = t.album_ref
            this.barcode = t.barcode
            this.has_mv = t.has_mv
            this.contract= t.contract ? t.contract : {
              service_fee_other :t.licensor.default_service_fee_other,
              service_fee_kr :t.licensor.default_service_fee_kr,
              territory : null,
              territory_exception : null,
              territory_exception_v2 : [],
              start_date : null,
              end_date : null,
            }
            this.contract.start_date = t.contract.start_date ? this.fixDate(t.contract.start_date) : null
            this.contract.end_date = t.contract.end_date ? this.fixDate(t.contract.end_date) : null
            this.country = t.country
            this.desired_release_date = t.desired_release_date
            this.release_date = t.release_date
            this.release_time = t.release_time
            this.original_release_date = t.original_release_date
            this.transfer_name = t.transfer_company
            this.transfer_date = t.transfer_date
            this.videoCount = t.video_count
            this.coverimage = t.coverimage
            if(t.coverimage_id){
              this.file1 = { ...t.coverimage, preview : t.coverimage.thumbnail.remote_path}
              this.files1 = []
            }

            if(t.labelimage_id){
              this.file2 = { ...t.labelimage, preview : t.labelimage.remote_path}
              this.files2 = []
            }
            
            this.label = t.label
            this.label_english = t.label_english
            this.label_language = t.label_language
            this.is_classical = !!t.is_classical
            this.apple_dj_mix = !!t.apple_dj_mix
            this.apple_compilation = !!t.apple_compilation
            this.apple_live = !!t.apple_live
            this.apple_cleared_fitness_plus = !!t.apple_cleared_fitness_plus
            this.apple_available_immersive_date = t.apple_available_immersive_date || null
            this.albumContributors = t.album_contributor_v2 || []
            this.albumWorks = t.album_work || []
            
            if(t.tags)this.tags = t.tags
            if(t.tags_v2)this.tags_v2 = t.tags_v2
            

            this.selectGenre = []
            this.rejectList.listData =  t.rejections 
            if(t.genre1_id) {
              this.selectGenre.push(t.genre1)
            }

            if(t.genre2_id) {
              this.selectGenre.push(t.genre2)
            }
            
            this.selectArtist = t.artists
        
            const track = []
            const numbering = [];
            this.trackAll = t.tracks
            for(var i in t.tracks){
              if(numbering.indexOf(t.tracks[i].volume-1) > -1){
                track[numbering.indexOf(t.tracks[i].volume-1)].push(t.tracks[i])
              }else{
                numbering.push(t.tracks[i].volume-1)
                track.push([t.tracks[i]])
                 
              }
            }
            this.trackList = track
            if(this.trackList.length ==  0 ) {
              this.trackList = [[]]
            }
            const assign = {}
            for(const tr of (t.tracks || [])){
              assign[tr.id] = { work_id: tr.album_work_id || null, movement_nr: tr.movement_nr || null }
            }
            this.trackWorkAssign = assign
            this.licensor_message = t.licensor_message
            this.export_contract_preset_id = t.export_contract_preset_id || null
            this.export_contract_preset_code = t.export_contract_preset?.code || null
            this.export_contract_preset_name = t.export_contract_preset?.name || null

            this.contractFile = t.contract_file

            let artists  = []

            for(let a in t.artists){
              artists.push(t.artists[a].display_name)
            }
            this.artistText = artists.join(', ')
            this.motionart11 = t.motionart11
            this.motionart11_id = t.motionart11_id
            this.motionart34 = t.motionart34
            this.motionart34_id = t.motionart34_id

            this.code_generation_in_progress = t.code_generation_in_progress

            if(this.code_generation_in_progress){
              this.alert({msg:'코드 생성이 진행중입니다. 완료 후 Slack으로 발송됩니다.'})
            }else{
            }
            this.$EventBus.$emit('headerSet',{
              title : `${this.name} ${this.album_ref? ' / '+this.album_ref+'' : '  '} ${this.barcode ? ' / '+ this.barcode : ''}`,
              subTitle : `발매일 : ${this.release_date? this.release_date + ' ' +this.release_time :'-'} / 아티스트 :  ${artists.join(', ')}   `
            })

            this.loadingHide();
        }).catch(error=>{
          const status = error.status
          switch(status){
              case 401:
              this.$store.dispatch('TOKEN_ITEM_CLEAR').then(()=>{this.$router.push('/login')})
              break;
              default:
                this.alert({msg:error})
              break;
          }
      })
    },


    //upc 수정
    openBarcode(){
      this.openModal('barcode')
      this.editType = 'new'
      this.existing_barcode = null
      this.codeReason = null
    },
    barcodeEditPut(){
      let payload = {
        id : `${this.$route.params.id}`,
        params : {
          "generate_new_barcode": this.editType == 'new' ? true : false,
          "reason": this.codeReason
        }        
      }
      if(this.valCheck(this.codeReason)){
        this.alert({msg:'사유를 입력해주세요.'})
        return false
      }
      if(this.editType == 'modify'){
        payload.params['existing_barcode'] = this.existing_barcode
      }
      this.loadingShow()
      this.$store.dispatch('PUT_BARCODE_GENERATE', payload)
        .then(result =>{
        this.barcode = result.data.barcode
        this.loadingHide()
        this.closeModal('barcode')
      }).catch(error =>{
        this.loadingHide();
        switch(error.response.data.code) {
          default:
            this.alert({msg:error.response.data.message})
            break;
        }
      })
    },
    //isrc 수정
    openISRC(){
      this.editType = 'new'
      this.existing_barcode = null
      this.generate_new_isrc = null
      this.codeReason = null
      this.openModal('isrc')

    },
    isrcEditPut(){
      let payload = {
        id : `${this.trackDetail.id}`,
        params : {
          "generate_new_isrc": this.editType == 'new' ? true : false,
          "reason": this.codeReason
        }        
      }
      if(this.valCheck(this.codeReason)){
        this.alert({msg:'사유를 입력해주세요.'})
        return false
      }
      if(this.editType == 'modify'){
        payload.params['existing_isrc'] = this.existing_isrc
      }
      this.loadingShow()
      this.$store.dispatch('PUT_ISRC_GENERATE', payload)
        .then(result =>{
        this.loadingHide()
        this.datacall()
        this.closeModal('isrc')
        this.trackDetail.isrc = result.data.isrc
      }).catch(error =>{
        this.loadingHide();
        switch(error.response.data.code) {
          default:
            this.alert({msg:error.response.data.message})
            break;
        }
      })
    },
    openDolbyISRC(){
      this.editType = 'new'
      this.existing_isrc = null
      this.generate_new_isrc = null
      this.codeReason = null
      this.openModal('dolbyIsrc')

    },
    dolbyIsrcEditPut(){
      let payload = {
        id : `${this.trackDetail.id}`,
        params : {
          "generate_new_isrc": this.editType == 'new' ? true : false,
          "reason": this.codeReason
        }        
      }
      if(this.valCheck(this.codeReason)){
        this.alert({msg:'사유를 입력해주세요.'})
        return false
      }
      if(this.editType == 'modify'){
        payload.params['existing_isrc'] = this.existing_isrc
      }
      this.loadingShow()
      this.$store.dispatch('PUT_DOLBY_ISRC_GENERATE', payload)
        .then(result =>{
        this.loadingHide()
        this.datacall()
        this.closeModal('dolbyIsrc')
        this.trackDetail.dolbyatmos_isrc = result.data.isrc
        
      }).catch(error =>{
        this.loadingHide();
        switch(error.response.data.code) {
          default:
            this.alert({msg:error.response.data.message})
            break;
        }
      })
    },

    loadPresetOptions() {
      this.$store.dispatch('GET_EXPORT_CONTRACT_PRESET_LIST', { page: 0, limit: 200 })
        .then((result) => {
          const items = result.items || result || []
          this.presetOptions = items
            .filter(i => !i.deleted_at)
            .map(i => ({
              value: i.id,
              label: `${i.name} (${i.code})`,
              code: i.code,
              name: i.name,
              contracts: i.export_contract_preset_export_contract || [],
              manual_dsps: i.manual_dsps || [],
            }))
          if (this.export_contract_preset_id) {
            this.selectedPreset = this.presetOptions.find(o => o.value === this.export_contract_preset_id) || null
          }
        })
        .catch(() => {})
    },
    onPresetSelected(opt) {
      const newId = opt ? opt.value : null
      if (opt) {
        this.export_contract_preset_id = opt.value
        this.export_contract_preset_code = opt.code
        this.export_contract_preset_name = opt.name
      } else {
        this.export_contract_preset_id = null
        this.export_contract_preset_code = null
        this.export_contract_preset_name = null
      }
      this.presetSelecting = false
      this.presetDetailExpanded = false

      this.$store.dispatch('PUT_ALBUM_V2', {
        id: this.$route.params.id,
        params: { export_contract_preset_id: newId },
      }).catch(() => {})
    },
    exceptionCountryAdd(){
      if(this.contract.territory_exception_v2.indexOf(this.exceptionCountry) < 0){
        this.contract.territory_exception_v2.push(this.exceptionCountry)
        this.exceptionCountry = null
      }else{
        this.alert({msg:'이미 등록된 국가 입니다.'})
      }
      
    },
    exceptionCountryRemove(index){
      this.contract.territory_exception_v2.splice(index,1)
    },
    addContributorV2(){

       this.openModal('contributor')
    },
    removeContributorV2(index){
      this.trackDetail.contributors_v2.splice(index,1)
    },
    openContributorV2NameEdit(tr){
      this.contributorV2NameEdit = {
        id: tr.id,
        name: tr.name,
        name_multilang: tr.name_multilang ? { ...tr.name_multilang } : {},
        name_export: tr.name_export ? { ...tr.name_export } : {},
        id_external: Array.isArray(tr.id_external) ? JSON.parse(JSON.stringify(tr.id_external)) : [],
      }
      this.contributorV2ExternalType = 'spotify'
      this.contributorV2ExternalValue = null
      this.contributorV2AppleOptions = []
      this.contributorV2AppleSelected = null
      this.contributorV2AppleLoading = false
      this.contributorV2AppleDirectInput = false
      this.contributorV2SpotifyOptions = []
      this.contributorV2SpotifySelected = null
      this.contributorV2SpotifyLoading = false
      this.contributorV2SpotifyDirectInput = false
      this.openModal('contributorV2NameEdit')
      const raiseZ = () => {
        const modal = document.querySelector('.vm--modal.contributor-v2-name-edit-modal')
        const overlay = document.querySelector('.vm--overlay[data-modal="contributorV2NameEdit"]')
        const container = (overlay && overlay.closest('.vm--container'))
          || (modal && modal.closest('.vm--container'))
        if (container) {
          container.style.setProperty('z-index', '999999', 'important')
          if (container.parentNode !== document.body || container.nextSibling) {
            document.body.appendChild(container)
          }
        }
        if (overlay) overlay.style.setProperty('z-index', '999999', 'important')
        if (modal) modal.style.setProperty('z-index', '999999', 'important')
        return !!container
      }
      this.$nextTick(() => {
        if (raiseZ()) return
        setTimeout(() => { if (raiseZ()) return; setTimeout(raiseZ, 150) }, 50)
      })
    },
    updateContributorV2NameMultilang(data){
      this.contributorV2NameEdit.name_multilang = data
    },
    updateContributorV2NameExport(data){
      this.contributorV2NameEdit.name_export = data
    },
    addContributorV2External(){
      if(!this.contributorV2ExternalType){
        this.alert({msg: '타입을 선택해주세요.'})
        return false
      }
      if(this.valCheck(this.contributorV2ExternalValue)){
        this.alert({msg: 'ID를 입력해주세요.'})
        return false
      }
      for (const item of this.contributorV2NameEdit.id_external) {
        if (item.type === this.contributorV2ExternalType) {
          this.alert({msg: '이미 등록된 타입입니다.'})
          return false
        }
      }
      this.contributorV2NameEdit.id_external.push({
        type: this.contributorV2ExternalType,
        value: this.contributorV2ExternalValue,
      })
      this.contributorV2ExternalValue = null
      this.contributorV2AppleSelected = null
      this.contributorV2AppleOptions = []
      this.contributorV2SpotifySelected = null
      this.contributorV2SpotifyOptions = []
    },
    removeContributorV2External(index){
      this.contributorV2NameEdit.id_external.splice(index, 1)
    },
    toggleContributorV2AppleInputMode(){
      this.contributorV2AppleDirectInput = !this.contributorV2AppleDirectInput
      this.contributorV2ExternalValue = null
      this.contributorV2AppleSelected = null
      this.contributorV2AppleOptions = []
    },
    onContributorV2AppleSearch(query){
      clearTimeout(this.contributorV2AppleTimer)
      if (!query || query.length < 2) {
        this.contributorV2AppleOptions = []
        this.contributorV2AppleLoading = false
        return
      }
      this.contributorV2AppleLoading = true
      this.contributorV2AppleTimer = setTimeout(() => this.fetchContributorV2AppleArtists(query), 300)
    },
    async fetchContributorV2AppleArtists(query){
      try {
        const response = await $api2.get('/proxy/apple-music/artists', { params: { term: query } })
        const artists = response.data?.data || []
        this.contributorV2AppleOptions = artists.map(a => ({
          id: a.id,
          label: `${a.name} (${a.id})`,
          thumbnail: a.thumbnail || null,
        }))
      } catch (e) {
        this.contributorV2AppleOptions = []
      } finally {
        this.contributorV2AppleLoading = false
      }
    },
    onContributorV2AppleSelect(option){
      if (option) {
        this.contributorV2ExternalValue = option.id
        this.contributorV2AppleSelected = option
      } else {
        this.contributorV2ExternalValue = null
        this.contributorV2AppleSelected = null
      }
    },
    toggleContributorV2SpotifyInputMode(){
      this.contributorV2SpotifyDirectInput = !this.contributorV2SpotifyDirectInput
      this.contributorV2ExternalValue = null
      this.contributorV2SpotifySelected = null
      this.contributorV2SpotifyOptions = []
    },
    onContributorV2SpotifySearch(query){
      clearTimeout(this.contributorV2SpotifyTimer)
      if (!query || query.length < 2) {
        this.contributorV2SpotifyOptions = []
        this.contributorV2SpotifyLoading = false
        return
      }
      this.contributorV2SpotifyLoading = true
      this.contributorV2SpotifyTimer = setTimeout(() => this.fetchContributorV2SpotifyArtists(query), 300)
    },
    async fetchContributorV2SpotifyArtists(query){
      try {
        const response = await $api2.get('/proxy/spotify/artists', { params: { term: query } })
        const artists = response.data?.data || []
        this.contributorV2SpotifyOptions = artists.map(a => ({
          id: a.id,
          name: a.name,
          label: `${a.name} (${a.id})`,
          thumbnail: a.thumbnail || null,
        }))
      } catch (e) {
        this.contributorV2SpotifyOptions = []
      } finally {
        this.contributorV2SpotifyLoading = false
      }
    },
    onContributorV2SpotifySelect(option){
      if (option) {
        this.contributorV2ExternalValue = `spotify:artist:${option.id}`
        this.contributorV2SpotifySelected = option
      } else {
        this.contributorV2ExternalValue = null
        this.contributorV2SpotifySelected = null
      }
    },
    getContributorV2ExternalUrl(type, value){
      if (!value) return null
      if (type === 'spotify') {
        const id = String(value).replace('spotify:artist:', '')
        return `https://open.spotify.com/artist/${id}`
      }
      if (type === 'apple') {
        return `https://music.apple.com/us/artist/${value}`
      }
      return null
    },
    saveContributorV2NameEdit(){
      if(!this.contributorV2NameEdit.name){
        this.alert({msg: '참여자 이름을 입력해주세요.'})
        return false
      }
      for (const key in this.contributorV2NameEdit.name_multilang) {
        if (!this.contributorV2NameEdit.name_multilang[key]) {
          delete this.contributorV2NameEdit.name_multilang[key]
        }
      }
      for (const storeKey in this.contributorV2NameEdit.name_export) {
        const inner = this.contributorV2NameEdit.name_export[storeKey]
        if (inner && typeof inner === 'object') {
          for (const langKey in inner) {
            if (!inner[langKey]) delete inner[langKey]
          }
          if (Object.keys(inner).length === 0) {
            delete this.contributorV2NameEdit.name_export[storeKey]
          }
        }
      }
      const payload = {
        id: this.contributorV2NameEdit.id,
        name: this.contributorV2NameEdit.name,
        name_multilang: this.contributorV2NameEdit.name_multilang,
        name_export: this.contributorV2NameEdit.name_export,
        id_external: this.contributorV2NameEdit.id_external,
      }
      this.$store.dispatch('PUT_CONTRIBUTOR_V2', payload).then(() => {
        this.noti('수정되었습니다.')
        for (const t of (this.trackDetail.contributors_v2 || [])) {
          if (t.id === payload.id) {
            t.name = payload.name
            t.name_multilang = { ...payload.name_multilang }
            t.name_export = { ...payload.name_export }
            t.id_external = JSON.parse(JSON.stringify(payload.id_external))
          }
        }
        this.closeModal('contributorV2NameEdit')
      }).catch(error => {
        this.alert({msg: error.response?.data?.message || '수정 실패'})
      })
    },
    addRole(data){
        if(this.selectContributor.role.includes(this.roleValue.value)){
            this.alert({msg: '이미 추가된 Role입니다.'})
            return false
        }
        this.selectContributor.role.push(this.roleValue.value)
        this.roleValue = null
    },
    removeRole(data){
        let index = this.selectContributor.role.findIndex(val => {
            return val == data.value
        })
        if(index > -1){
            this.selectContributor.role.splice(index,1)
        }
    },
    addInst(data){

        if(this.selectContributor.instrument.includes(this.instValue.value)){
            this.alert({msg: '이미 추가된 Instrument입니다.'})
            return false
        }
        this.selectContributor.instrument.push(this.instValue.value)
        
        this.instValue = null
    },
    removeInst(data){
        let index = this.selectContributor.instrument.findIndex(val => {
            return val == data.value
        })
        if(index > -1){
            this.selectContributor.instrument.splice(index,1)
        }
    },
    editContributor(item){
        let data = JSON.parse(JSON.stringify(item))
        this.selectContributor = {...data}
        this.roleValue = null
        this.instValue = null
        this.openModal('contributorEdit')
    },
    saveContributor(){
        let data = this.selectContributor
        
        if(!data.role.length && !data.instrument.length){
            this.alert({msg: this.lang('한가지 이상의 Role 또는 Instrument을 선택해주세요.','   Please select at least one Role or Instrument.')})
            return false
        }
        let index = this.trackDetail.contributors_v2.findIndex(val => {
            return val.id == this.selectContributor.id
        })
        if(-1 < index){
            this.trackDetail.contributors_v2.splice(index,1,this.selectContributor)
        }
        this.closeModal('contributorEdit')
    },
    contributorAdd(data){
      console.log(data)
    },

    submitGenerateJobs() {
      const params = {
        album_id: parseInt(this.$route.params.id),
        autostart: this.generateForm.autostart,
      }
      if (this.generateForm.action) {
        params.action = this.generateForm.action
      }
      this.loadingShow()
      this.$store.dispatch('POST_EXPORT_JOB_GENERATE', { params })
        .then((result) => {
          this.loadingHide()
          const jobs = Array.isArray(result) ? result : (result.data || result.items || [])
          this.generateResult = jobs
        })
        .catch((error) => {
          this.loadingHide()
          const msg = error.response && error.response.data
            ? error.response.data.message
            : 'Export Job 생성 중 오류가 발생했습니다.'
          this.alert({ msg })
        })
    },

    closeGenerateModal() {
      this.generateResult = null
      this.generateForm = { action: null, autostart: true }
      this.closeModal('generateExportJobs')
    },

    // Album Contributor methods
    async getAlbumContributors() {
      const albumId = this.$route.params.id
      try {
        const res = await $api2.get(`/admin/album/${albumId}/contributor`)
        this.albumContributors = res.data || []
      } catch (e) {
        console.error(e)
      }
    },
    async searchAlbumContributorList() {
      if (!this.albumContributorSearch) return
      try {
        const res = await $api2.get('/admin/contributor', { params: { search: this.albumContributorSearch } })
        this.albumContributorSearchResults = res.data.data || []
      } catch (e) {
        this.albumContributorSearchResults = []
      }
    },
    openAddAlbumContributor() {
      this.albumContributorSearch = ''
      this.albumContributorSearchResults = []
      this.albumContributorSelectItem = null
      this.albumContributorRoles = []
      this.albumContributorInstruments = []
      this.albumContributorIsPrimary = false
      this.editingAlbumContributor = null
      this.openModal('albumContributorModal')
    },
    openEditAlbumContributor(item) {
      this.albumContributorSelectItem = item.contributor_v2
      this.albumContributorRoles = [...(item.role || [])]
      this.albumContributorInstruments = [...(item.instrument || [])]
      this.albumContributorIsPrimary = item.is_primary || false
      this.editingAlbumContributor = item
      this.openModal('albumContributorModal')
    },
    async saveAlbumContributor() {
      const albumId = this.$route.params.id
      const body = {
        contributor_id: this.albumContributorSelectItem?.id,
        role: this.albumContributorRoles,
        instrument: this.albumContributorInstruments,
        is_primary: this.albumContributorIsPrimary,
      }
      try {
        if (this.editingAlbumContributor) {
          await $api2.put(`/admin/album/${albumId}/contributor/${this.editingAlbumContributor.id}`, body)
        } else {
          await $api2.post(`/admin/album/${albumId}/contributor`, body)
        }
        this.closeModal('albumContributorModal')
        await this.getAlbumContributors()
      } catch (e) {
        this.alert({ msg: '저장 실패' })
      }
    },
    async removeAlbumContributor(id) {
      const albumId = this.$route.params.id
      try {
        await $api2.delete(`/admin/album/${albumId}/contributor/${id}`)
        await this.getAlbumContributors()
      } catch (e) {
        this.alert({ msg: '삭제 실패' })
      }
    },
    // Album Work methods
    async getAlbumWorks() {
      const albumId = this.$route.params.id
      try {
        const res = await $api2.get(`/admin/album/${albumId}/work`)
        this.albumWorks = res.data || []
      } catch (e) {
        console.error(e)
      }
    },
    openAddAlbumWork() {
      this.editingAlbumWork = null
      this.albumWorkForm = { work_name: '', work_type: '', sequence_nr: 0 }
      this.openModal('albumWorkModal')
    },
    openEditAlbumWork(item) {
      this.editingAlbumWork = item
      this.albumWorkForm = { work_name: item.work_name, work_type: item.work_type || '', sequence_nr: item.sequence_nr || 0 }
      this.openModal('albumWorkModal')
    },
    async saveAlbumWork() {
      const albumId = this.$route.params.id
      try {
        if (this.editingAlbumWork) {
          await $api2.put(`/admin/album/${albumId}/work/${this.editingAlbumWork.id}`, {
            work_type: this.albumWorkForm.work_type,
            sequence_nr: this.albumWorkForm.sequence_nr,
          })
        } else {
          await $api2.post(`/admin/album/${albumId}/work`, this.albumWorkForm)
        }
        this.closeModal('albumWorkModal')
        await this.getAlbumWorks()
      } catch (e) {
        this.alert({ msg: '저장 실패' })
      }
    },
    async removeAlbumWork(id) {
      const albumId = this.$route.params.id
      try {
        await $api2.delete(`/admin/album/${albumId}/work/${id}`)
        await this.getAlbumWorks()
      } catch (e) {
        this.alert({ msg: '삭제 실패' })
      }
    },
    formatPreviewTime(seconds) {
      const m = Math.floor(seconds / 60)
      const s = seconds % 60
      return `${m}:${String(s).padStart(2, '0')}`
    },
    async onPreviewConfirm(payload) {
      await this.addPreview(payload)
    },
    async addPreview({ start_point, end_point, platform }) {
      if (start_point === null || end_point === null) {
        this.alert({ msg: 'Start와 End를 입력해주세요.' })
        return
      }
      if (start_point < 0 || end_point < 0) {
        this.alert({ msg: 'Start와 End는 0 이상이어야 합니다.' })
        return
      }
      if (start_point >= end_point) {
        this.alert({ msg: 'Start는 End보다 작아야 합니다.' })
        return
      }
      try {
        const res = await $api2.post(`/admin/track/${this.trackDetail.id}/previews`, {
          start_point: parseInt(start_point),
          end_point: parseInt(end_point),
          platform,
        })
        this.trackDetail.track_preview = [...(this.trackDetail.track_preview || []), res.data]
        this.showPreviewPicker = false
      } catch (e) {
        this.alert({ msg: '프리뷰 추가 실패' })
      }
    },
    playPreview(preview) {
      const files = this.trackDetail.files
      if (!files || !files.length) return
      const url = files[0].remote_path
      if (!url) return

      if (this.previewPlayingId === preview.id) {
        this.stopPreview()
        return
      }

      this.stopPreview()

      if (!this._previewAudio) this._previewAudio = new Audio()
      const audio = this._previewAudio

      const onTimeUpdate = () => {
        if (audio.currentTime >= preview.end_point) this.stopPreview()
      }
      const onEnded = () => { this.previewPlayingId = null }

      audio._cleanup = () => {
        audio.removeEventListener('timeupdate', onTimeUpdate)
        audio.removeEventListener('ended', onEnded)
      }
      audio.addEventListener('timeupdate', onTimeUpdate)
      audio.addEventListener('ended', onEnded)
      audio.src = url
      audio.currentTime = preview.start_point
      this.previewPlayingId = preview.id
      audio.play().catch(() => { this.previewPlayingId = null })
    },
    stopPreview() {
      if (this._previewAudio) {
        this._previewAudio.pause()
        if (this._previewAudio._cleanup) {
          this._previewAudio._cleanup()
          this._previewAudio._cleanup = null
        }
      }
      this.previewPlayingId = null
    },
    async removePreview(previewId, index) {
      try {
        await $api2.delete(`/admin/track/${this.trackDetail.id}/previews/${previewId}`)
        const updated = [...(this.trackDetail.track_preview || [])]
        updated.splice(index, 1)
        this.trackDetail.track_preview = updated
      } catch (e) {
        this.alert({ msg: '프리뷰 삭제 실패' })
      }
    },
    async saveTrackWorkAssignments() {
      const albumId = this.$route.params.id
      try {
        const calls = Object.entries(this.trackWorkAssign).map(([trackId, val]) =>
          $api2.put(`/admin/album/${albumId}/track/${trackId}`, {
            album_work_id: val.work_id || null,
            movement_nr: val.movement_nr || null,
          })
        )
        await Promise.all(calls)
        this.noti('악장 배정이 저장되었습니다.')
      } catch (e) {
        this.alert({ msg: '저장 실패' })
      }
    },
  }
}
</script>

<style scoped>

/* DSP Group card */
.dsp-group-card {
  display: block;
  border: 1px solid #e4e4e4;
  border-radius: 6px;
  background: #fff;
  max-width: 420px;
  overflow: hidden;
  transition: border-color 0.15s;
}
.dsp-group-card.is-dark {
  background: #10163a;
  border-color: #414561;
}

.dsp-card-main {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 9px 12px;
  cursor: pointer;
  user-select: none;
  gap: 12px;
}
.dsp-group-card:not(.is-dark) .dsp-card-main:hover {
  background: #fafafa;
}
.dsp-group-card.is-dark .dsp-card-main:hover {
  background: rgba(255,255,255,0.03);
}

.dsp-card-identity {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
  min-width: 0;
}

.dsp-card-name {
  font-weight: 600;
  font-size: 13px;
  color: #2c2c3e;
  white-space: nowrap;
}
.dsp-group-card.is-dark .dsp-card-name {
  color: #c2c6dc;
}

.dsp-card-code {
  background: #f0f0f0;
  padding: 1px 7px;
  border-radius: 3px;
  font-size: 11px;
  font-family: monospace;
  line-height: 1.6;
  color: #555;
  white-space: nowrap;
}
.dsp-group-card.is-dark .dsp-card-code {
  background: #1e2748;
  color: #9ba5d4;
}

.dsp-card-count {
  font-size: 11px;
  font-weight: 600;
  color: #7b84c4;
  background: rgba(123,132,196,0.12);
  padding: 1px 7px;
  border-radius: 10px;
  white-space: nowrap;
}

.dsp-card-actions {
  display: flex;
  align-items: center;
  gap: 4px;
  flex-shrink: 0;
}

.dsp-btn-change {
  background: transparent;
  border: 1px solid #d0d0d0;
  color: #888;
  padding: 2px 10px;
  border-radius: 4px;
  font-size: 11px;
  cursor: pointer;
  transition: all 0.15s;
  line-height: 1.6;
}
.dsp-btn-change:hover {
  border-color: #7b84c4;
  color: #7b84c4;
}
.dsp-group-card.is-dark .dsp-btn-change {
  border-color: #414561;
  color: #6b7094;
}
.dsp-group-card.is-dark .dsp-btn-change:hover {
  border-color: #7b84c4;
  color: #7b84c4;
}

.dsp-btn-expand {
  background: transparent;
  border: none;
  padding: 3px;
  cursor: pointer;
  color: #aaa;
  display: flex;
  align-items: center;
  transition: transform 0.2s cubic-bezier(0.4, 0, 0.2, 1), color 0.15s;
  line-height: 1;
}
.dsp-btn-expand.is-open {
  transform: rotate(180deg);
  color: #7b84c4;
}

/* Expandable detail section */
.dsp-card-detail {
  display: grid;
  grid-template-rows: 0fr;
  transition: grid-template-rows 0.22s cubic-bezier(0.4, 0, 0.2, 1);
}
.dsp-card-detail.is-open {
  grid-template-rows: 1fr;
}
.dsp-card-detail__inner {
  overflow: hidden;
  padding: 0 12px;
}
.dsp-card-detail.is-open .dsp-card-detail__inner {
  padding: 0 12px 10px;
  border-top: 1px solid #f0f0f0;
}
.dsp-group-card.is-dark .dsp-card-detail.is-open .dsp-card-detail__inner {
  border-top-color: #414561;
}

.dsp-contract-list {
  display: flex;
  flex-wrap: wrap;
  gap: 5px;
  padding-top: 8px;
}

.dsp-contract-chip {
  background: #f5f5f5;
  border: 1px solid #e8e8e8;
  border-radius: 4px;
  font-size: 11px;
  padding: 2px 8px;
  color: #555;
  line-height: 1.6;
}
.dsp-group-card.is-dark .dsp-contract-chip {
  background: #1e2748;
  border-color: #414561;
  color: #9ba5d4;
}

.dsp-contract-chip--manual {
  background: transparent;
  border-style: dashed;
  border-color: #c8c8c8;
  color: #888;
}
.dsp-group-card.is-dark .dsp-contract-chip--manual {
  border-color: #3a4166;
  color: #5e6888;
}

.dsp-manual-divider {
  width: 100%;
  height: 1px;
  background: #efefef;
  margin: 7px 0 5px;
}
.dsp-group-card.is-dark .dsp-manual-divider {
  background: #252d55;
}

/* Selector panel — same feel as matched card */
.dsp-selector-panel {
  border: 1px solid #e4e4e4;
  border-radius: 6px;
  background: #fff;
  max-width: 420px;
  overflow: visible;
}
.dsp-selector-panel.is-dark {
  background: #10163a;
  border-color: #414561;
}

.dsp-selector-body {
  padding: 10px 12px 8px;
}

.dsp-selector-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 6px 12px 8px;
  border-top: 1px solid #f0f0f0;
}
.dsp-selector-panel.is-dark .dsp-selector-footer {
  border-top-color: #414561;
}

.dsp-btn-cancel {
  background: transparent;
  border: none;
  color: #aaa;
  padding: 0;
  font-size: 12px;
  cursor: pointer;
  transition: color 0.15s;
  line-height: 1;
}
.dsp-btn-cancel:hover {
  color: #ea5455;
}
.dsp-selector-panel.is-dark .dsp-btn-cancel {
  color: #5a5f80;
}
.dsp-selector-panel.is-dark .dsp-btn-cancel:hover {
  color: #ea5455;
}

.dsp-new-link {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-size: 12px;
  color: #7b84c4;
  text-decoration: none;
  transition: color 0.15s;
  margin-left: auto;
}
.dsp-new-link:hover {
  color: #5a64b0;
  text-decoration: none;
}

/* Delivery action footer */
.dsp-card-footer {
  border-top: 1px solid #f0f0f0;
  padding: 7px 12px;
  background: #fafbff;
  border-radius: 0 0 6px 6px;
}
.dsp-card-footer.is-dark {
  background: #0c1236;
  border-top-color: #414561;
}

.dsp-btn-deliver {
  display: inline-flex;
  align-items: center;
  background: transparent;
  border: none;
  padding: 0;
  font-size: 12px;
  font-weight: 500;
  color: #7b84c4;
  cursor: pointer;
  transition: color 0.15s;
  line-height: 1;
}
.dsp-btn-deliver:hover {
  color: #5056a0;
}
.dsp-card-footer.is-dark .dsp-btn-deliver {
  color: #6b74b8;
}
.dsp-card-footer.is-dark .dsp-btn-deliver:hover {
  color: #9099d8;
}
.dsp-btn-deliver.is-disabled {
  color: #bbb;
  cursor: not-allowed;
}
.dsp-btn-deliver.is-disabled:hover {
  color: #bbb;
}
.dsp-card-footer.is-dark .dsp-btn-deliver.is-disabled {
  color: #444b6e;
}
.dsp-card-footer.is-dark .dsp-btn-deliver.is-disabled:hover {
  color: #444b6e;
}
/* Delivery job action chips */
.djob-action-chip {
  background: transparent;
  border: 1px solid #d8d8e4;
  color: #aaa;
  padding: 4px 12px;
  border-radius: 4px;
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.03em;
  cursor: pointer;
  transition: all 0.15s;
  line-height: 1.5;
}
.djob-action-chip.chip-green { border-color: #d4edda; color: #4caf7d; }
.djob-action-chip.chip-yellow { border-color: #ffeeba; color: #e0a020; }
.djob-action-chip.chip-red { border-color: #f8d7da; color: #e05555; }
.djob-action-chip.chip-green:hover,
.djob-action-chip.chip-green.is-active { background: #28c76f; border-color: #28c76f; color: #fff; }
.djob-action-chip.chip-yellow:hover,
.djob-action-chip.chip-yellow.is-active { background: #ff9f43; border-color: #ff9f43; color: #fff; }
.djob-action-chip.chip-red:hover,
.djob-action-chip.chip-red.is-active { background: #ea5455; border-color: #ea5455; color: #fff; }

.dsp-deliver-state-hint {
  font-size: 11px;
  font-weight: 400;
  margin-left: 4px;
  opacity: 0.7;
}

/* ─── Classical Workspace (tab layout) ─── */
/* ─── Classical Workspace (cws) — light-first ─────────── */
.cws-workspace {
  display: flex;
  gap: 0;
  min-height: 500px;
  border-radius: 6px;
  overflow: hidden;
  border: 1px solid #e4e6ef;
  background: #fff;
}

.cws-sidebar {
  width: 280px;
  flex-shrink: 0;
  border-right: 1px solid #e4e6ef;
  display: flex;
  flex-direction: column;
}

.cws-main {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
}

.cws-section {
  padding: 14px 16px;
}

.cws-section__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 10px;
}

.cws-section__label {
  font-family: 'Montserrat', sans-serif;
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  color: #b0b5c8;
}

.cws-add-btn {
  font-family: 'Montserrat', sans-serif;
  font-size: 11px;
  font-weight: 600;
  color: #28c76f;
  background: transparent;
  border: 1px solid #28c76f30;
  border-radius: 4px;
  padding: 3px 8px;
  cursor: pointer;
  transition: background 0.12s, border-color 0.12s;
  line-height: 1.4;
}
.cws-add-btn:hover {
  background: #28c76f18;
  border-color: #28c76f60;
}

.cws-work-row {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 6px 8px;
  border-radius: 4px;
  margin-bottom: 2px;
  transition: background 0.1s;
}
.cws-work-row:hover { background: #f5f6fb; }

.cws-work-row__seq {
  font-family: 'Montserrat', sans-serif;
  font-size: 10px;
  font-weight: 700;
  color: #c8cce0;
  width: 16px;
  text-align: right;
  flex-shrink: 0;
}

.cws-work-row__info {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 1px;
}

.cws-work-row__name {
  font-family: 'Montserrat', sans-serif;
  font-size: 12px;
  font-weight: 600;
  color: #2c2c3e;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.cws-work-row__type {
  font-family: 'Montserrat', sans-serif;
  font-size: 10px;
  font-weight: 400;
  color: #b0b5c8;
}

.cws-work-row__actions {
  display: flex;
  gap: 4px;
  opacity: 0;
  transition: opacity 0.1s;
}
.cws-work-row:hover .cws-work-row__actions,
.cws-contrib-row:hover .cws-work-row__actions { opacity: 1; }

.cws-icon-btn {
  background: transparent;
  border: none;
  color: #c8cce0;
  cursor: pointer;
  font-size: 13px;
  padding: 2px 4px;
  border-radius: 3px;
  line-height: 1;
  transition: color 0.1s, background 0.1s;
}
.cws-icon-btn:hover { color: #2c2c3e; background: #eef0f8; }
.cws-icon-btn--danger:hover { color: #ea5455; background: #ea545518; }

.cws-contrib-row {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 6px 8px;
  border-radius: 4px;
  margin-bottom: 2px;
  transition: background 0.1s;
}
.cws-contrib-row:hover { background: #f5f6fb; }

.cws-contrib-row__info {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 1px;
}

.cws-contrib-row__name {
  font-family: 'Montserrat', sans-serif;
  font-size: 12px;
  font-weight: 600;
  color: #2c2c3e;
}

.cws-contrib-row__meta {
  font-family: 'Montserrat', sans-serif;
  font-size: 10px;
  color: #b0b5c8;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.cws-divider {
  height: 1px;
  background: #e4e6ef;
  margin: 0 16px;
}

.cws-empty {
  font-family: 'Montserrat', sans-serif;
  font-size: 11px;
  color: #c8cce0;
  padding: 8px;
  margin: 0;
}

.cws-assign-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 16px;
  border-bottom: 1px solid #e4e6ef;
  background: #fafbfd;
  flex-shrink: 0;
}

.cws-assign-title {
  display: flex;
  align-items: center;
  gap: 10px;
  font-family: 'Montserrat', sans-serif;
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: #2c2c3e;
}

.cws-assign-icon {
  font-size: 18px;
  line-height: 1;
  color: #28c76f;
  font-style: normal;
}

.cws-assign-count {
  font-weight: 400;
  letter-spacing: 0;
  text-transform: none;
  font-size: 11px;
  color: #b0b5c8;
}

.cws-no-works {
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 1;
  font-family: 'Montserrat', sans-serif;
  font-size: 12px;
  color: #c8cce0;
  padding: 40px 20px;
  text-align: center;
}

/* Table */
.classical-table {
  width: 100%;
  display: flex;
  flex-direction: column;
}

.classical-table__head,
.classical-table__row {
  display: grid;
  grid-template-columns: 36px 1fr 220px 72px;
  align-items: center;
  gap: 0;
}

.classical-table__head {
  padding: 6px 16px;
  background: #f5f6fb;
  border-bottom: 1px solid #e4e6ef;
  font-family: 'Montserrat', sans-serif;
  font-size: 10px;
  font-weight: 600;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  color: #b0b5c8;
}

.classical-table__row {
  padding: 5px 16px;
  border-bottom: 1px solid #f0f1f8;
  transition: background 0.12s;
  min-height: 38px;
}
.classical-table__row:last-child { border-bottom: none; }
.classical-table__row:hover { background: #f5f6fb; }
.classical-table__row.is-assigned { background: rgba(40, 199, 111, 0.04); }
.classical-table__row.is-assigned:hover { background: rgba(40, 199, 111, 0.07); }

.col-nr {
  font-family: 'Montserrat', sans-serif;
  font-size: 11px;
  font-weight: 600;
  color: #c8cce0;
  text-align: right;
  padding-right: 12px;
}
.classical-table__head .col-nr { text-align: right; }

.col-title {
  font-family: 'Montserrat', sans-serif;
  font-size: 13px;
  font-weight: 500;
  color: #2c2c3e;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  padding-right: 16px;
}

.col-work { padding-right: 12px; }
.col-mvt { display: flex; align-items: center; }

/* v-select inside table — light */
.classical-select .vs__dropdown-toggle {
  background: #fff !important;
  border: 1px solid #e4e6ef !important;
  border-radius: 4px !important;
  padding: 2px 6px !important;
  min-height: 28px !important;
}
.classical-select .vs__selected {
  font-size: 12px !important;
  color: #2c2c3e !important;
  margin: 0 !important;
  padding: 0 !important;
}
.classical-select .vs__search {
  font-size: 12px !important;
  color: #2c2c3e !important;
}
.classical-select .vs__search::placeholder { color: #c8cce0 !important; }
.classical-select .vs__open-indicator { fill: #c8cce0 !important; }
.classical-select .vs__clear { fill: #c8cce0 !important; }

.classical-mvt-input {
  width: 52px;
  height: 28px;
  background: #fff;
  border: 1px solid #e4e6ef;
  border-radius: 4px;
  color: #2c2c3e;
  font-family: 'Montserrat', sans-serif;
  font-size: 12px;
  font-weight: 600;
  text-align: center;
  padding: 0 6px;
  outline: none;
  transition: border-color 0.12s;
  -moz-appearance: textfield;
}
.classical-mvt-input::-webkit-outer-spin-button,
.classical-mvt-input::-webkit-inner-spin-button { -webkit-appearance: none; }
.classical-mvt-input::placeholder { color: #c8cce0; }
.classical-mvt-input:focus { border-color: #28c76f; }

/* ─── Dark mode overrides ──────────────────────────────── */
.cws-dark.cws-workspace { background: #10163a; border-color: #2d3356; }
.cws-dark .cws-sidebar { border-right-color: #2d3356; }
.cws-dark .cws-section__label { color: #5a5f7d; }
.cws-dark .cws-work-row:hover { background: #1c2246; }
.cws-dark .cws-work-row__seq { color: #5a5f7d; }
.cws-dark .cws-work-row__name { color: #ebeefd; }
.cws-dark .cws-work-row__type { color: #5a5f7d; }
.cws-dark .cws-icon-btn { color: #5a5f7d; }
.cws-dark .cws-icon-btn:hover { color: #c2c6dc; background: #2d3356; }
.cws-dark .cws-contrib-row:hover { background: #1c2246; }
.cws-dark .cws-contrib-row__name { color: #ebeefd; }
.cws-dark .cws-contrib-row__meta { color: #5a5f7d; }
.cws-dark .cws-divider { background: #2d3356; }
.cws-dark .cws-empty { color: #414561; }
.cws-dark .cws-assign-header { background: #0d1230; border-bottom-color: #2d3356; }
.cws-dark .cws-assign-title { color: #c2c6dc; }
.cws-dark .cws-assign-count { color: #5a5f7d; }
.cws-dark .cws-no-works { color: #414561; }
.cws-dark .classical-table__head { background: #0d1230; border-bottom-color: #2d3356; color: #5a5f7d; }
.cws-dark .classical-table__row { border-bottom-color: #1c2246; }
.cws-dark .classical-table__row:hover { background: #171d42; }
.cws-dark .classical-table__row.is-assigned { background: #111838; }
.cws-dark .classical-table__row.is-assigned:hover { background: #161e45; }
.cws-dark .col-nr { color: #5a5f7d; }
.cws-dark .col-title { color: #ebeefd; }
.cws-dark .classical-select .vs__dropdown-toggle { background: #1c2246 !important; border-color: #2d3356 !important; }
.cws-dark .classical-select .vs__selected { color: #c2c6dc !important; }
.cws-dark .classical-select .vs__search { color: #c2c6dc !important; }
.cws-dark .classical-select .vs__search::placeholder { color: #5a5f7d !important; }
.cws-dark .classical-select .vs__open-indicator { fill: #5a5f7d !important; }
.cws-dark .classical-select .vs__clear { fill: #5a5f7d !important; }
.cws-dark .classical-mvt-input { background: #1c2246; border-color: #2d3356; color: #ebeefd; }
.cws-dark .classical-mvt-input::placeholder { color: #5a5f7d; }

/* ─── Track Preview section ─── */
.preview-list {
  list-style: none;
  margin: 0;
  padding: 0;
}
.preview-item {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 7px 8px;
  border-radius: 4px;
  border-bottom: 1px solid rgba(65, 69, 97, 0.3);
  transition: background 0.12s ease;
}
.preview-item:last-child {
  border-bottom: none;
}
.preview-item:hover {
  background: rgba(123, 132, 196, 0.05);
}
.preview-platform-badge {
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.07em;
  padding: 2px 7px;
  border-radius: 3px;
  text-transform: uppercase;
  white-space: nowrap;
  line-height: 1.5;
}
.preview-platform-badge.tiktok {
  background: rgba(238, 29, 82, 0.1);
  color: #ee1d52;
  border: 1px solid rgba(238, 29, 82, 0.22);
}
.preview-time-range {
  display: flex;
  align-items: center;
  gap: 5px;
  font-size: 13px;
  font-weight: 600;
  color: #c2c6dc;
  letter-spacing: 0.02em;
}
.preview-arrow {
  font-size: 11px;
  color: #7b84c4;
}
.preview-duration {
  font-size: 11px;
  color: #6b7094;
}
.preview-play-btn {
  width: 24px;
  height: 24px;
  border-radius: 50%;
  border: 1px solid rgba(65, 69, 97, 0.7);
  background: transparent;
  color: #7b84c4;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  padding: 0;
  transition: background 0.12s ease, border-color 0.12s ease, color 0.12s ease;
}
.preview-play-btn:hover:not(:disabled) {
  background: rgba(40, 199, 111, 0.12);
  border-color: #28c76f;
  color: #28c76f;
}
.preview-play-btn.is-playing {
  background: rgba(40, 199, 111, 0.15);
  border-color: #28c76f;
  color: #28c76f;
}
.preview-play-btn:disabled {
  opacity: 0.3;
  cursor: default;
}
.preview-delete-btn {
  margin-left: auto;
  background: transparent;
  border: 1px solid transparent;
  cursor: pointer;
  width: 26px;
  height: 26px;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  line-height: 1;
  color: #6b7094;
  transition: background 0.12s ease, border-color 0.12s ease, color 0.12s ease;
  flex-shrink: 0;
  padding: 0;
}
.preview-delete-btn:hover {
  background: rgba(234, 84, 85, 0.1);
  border-color: rgba(234, 84, 85, 0.3);
  color: #ea5455;
}
.preview-empty-state {
  font-size: 12px;
  color: #6b7094;
  padding: 6px 8px;
}
.preview-new-track-note {
  font-size: 12px;
  color: #6b7094;
  font-style: italic;
  padding: 6px 0;
}

/* ─── Apple Music Settings ─────────────────────────────── */
.am-flags-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(168px, 1fr));
  gap: 8px;
}

/* Light mode */
.am-flag-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 11px 13px;
  border-radius: 7px;
  border: 1.5px solid #e8eaf0;
  background: #fafbfd;
  cursor: pointer;
  user-select: none;
  gap: 10px;
  transition: border-color 0.18s ease, background 0.18s ease, box-shadow 0.18s ease;
}
.am-flag-item:hover {
  border-color: #d0d3e0;
  background: #f5f6fb;
}
.am-flag-item--on {
  border-color: rgba(252, 60, 68, 0.4);
  background: rgba(252, 60, 68, 0.04);
  box-shadow: 0 0 0 3px rgba(252, 60, 68, 0.06);
}
.am-flag-item--on:hover {
  border-color: rgba(252, 60, 68, 0.6);
  background: rgba(252, 60, 68, 0.06);
}

/* Dark mode flag items */
.am-dark .am-flag-item {
  border-color: #414561;
  background: #1e2748;
}
.am-dark .am-flag-item:hover {
  border-color: #565d8a;
  background: #232c57;
}
.am-dark .am-flag-item--on {
  border-color: rgba(252, 60, 68, 0.45);
  background: rgba(252, 60, 68, 0.08);
  box-shadow: 0 0 0 3px rgba(252, 60, 68, 0.08);
}
.am-dark .am-flag-item--on:hover {
  border-color: rgba(252, 60, 68, 0.65);
  background: rgba(252, 60, 68, 0.11);
}

.am-flag-content {
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
}

.am-flag-name {
  font-size: 12.5px;
  font-weight: 600;
  color: #2c2c3e;
  line-height: 1.3;
  white-space: nowrap;
}
.am-dark .am-flag-name {
  color: #c2c6dc;
}
.am-flag-item--on .am-flag-name {
  color: #d42028;
}
.am-dark .am-flag-item--on .am-flag-name {
  color: #ff6b6e;
}

.am-flag-sub {
  font-size: 10.5px;
  color: #aaa;
  line-height: 1.3;
}
.am-dark .am-flag-sub {
  color: #6b7094;
}
.am-flag-item--on .am-flag-sub {
  color: rgba(212, 32, 40, 0.6);
}
.am-dark .am-flag-item--on .am-flag-sub {
  color: rgba(255, 107, 110, 0.55);
}

/* Toggle switch */
.am-switch {
  position: relative;
  flex-shrink: 0;
}
.am-switch-input {
  position: absolute;
  opacity: 0;
  width: 0;
  height: 0;
  pointer-events: none;
}
.am-switch-track {
  display: block;
  width: 34px;
  height: 19px;
  border-radius: 10px;
  background: #dde1e7;
  position: relative;
  transition: background 0.2s cubic-bezier(0.4, 0, 0.2, 1);
}
.am-dark .am-switch-track {
  background: #414561;
}
.am-switch-track::after {
  content: '';
  position: absolute;
  top: 2px;
  left: 2px;
  width: 15px;
  height: 15px;
  border-radius: 50%;
  background: #fff;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.22);
  transition: transform 0.2s cubic-bezier(0.4, 0, 0.2, 1);
}
.am-switch-input:checked ~ .am-switch-track {
  background: #fc3c44;
}
.am-switch-input:checked ~ .am-switch-track::after {
  transform: translateX(15px);
}

/* Fitness+ Immersive date reveal */
.am-immersive-reveal {
  display: grid;
  grid-template-rows: 0fr;
  transition: grid-template-rows 0.24s cubic-bezier(0.4, 0, 0.2, 1),
              margin-top 0.24s cubic-bezier(0.4, 0, 0.2, 1);
  margin-top: 0;
}
.am-immersive-reveal--open {
  grid-template-rows: 1fr;
  margin-top: 10px;
}
.am-immersive-inner {
  overflow: hidden;
}
.am-immersive-row {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 14px;
  border-radius: 7px;
  border: 1.5px solid rgba(252, 60, 68, 0.25);
  background: rgba(252, 60, 68, 0.03);
}
.am-dark .am-immersive-row {
  border-color: rgba(252, 60, 68, 0.3);
  background: rgba(252, 60, 68, 0.07);
}
.am-immersive-label {
  font-size: 12.5px;
  font-weight: 600;
  color: #c02028;
  white-space: nowrap;
  flex-shrink: 0;
}
.am-dark .am-immersive-label {
  color: #ff6b6e;
}

</style>

<style>
.vm--container:has(> .vm--overlay[data-modal="contributorV2NameEdit"]),
.vm--container:has(> .vm--modal.contributor-v2-name-edit-modal),
.vm--container:has(.vm--modal.contributor-v2-name-edit-modal) {
  z-index: 100000 !important;
}
</style>
